import { hasZoneOrOffset as Ta } from "./utils/normalizeToZonedDateTime/hasZoneOrOffset.js";
const Da = globalThis.Temporal, Sa = (n, t) => `Non-positive ${n}: ${t}`, ba = (n, t) => `Non-finite ${n}: ${t}`, Fa = (n) => `Cannot convert bigint to ${n}`, Oa = "Invalid object", Rr = (n, t, e, o) => zt(n, t) + `; must be between ${e}-${o}`, zt = (n, t) => `Invalid ${n}: ${t}`, Pa = 1e3, Ca = 1e6, Za = 1e9, Ea = 6e10, wa = 36e11;
function Dn(n) {
  return n === void 0 ? /* @__PURE__ */ Object.create(null) : Xt(n);
}
function li(n, t = "number") {
  if (typeof n == "bigint")
    throw new TypeError(Fa(t));
  if (n = Number(n), !Number.isFinite(n))
    throw new RangeError(ba(t, n));
  return n;
}
function J(n, t) {
  return Math.trunc(li(n, t)) || 0;
}
function Ar(n, t) {
  return Ba(J(n, t), t);
}
function Ba(n, t = "number") {
  if (n <= 0)
    throw new RangeError(Sa(t, n));
  return n;
}
function Ya(n, t, e) {
  return Math.min(Math.max(n, t), e);
}
function To(n) {
  return n !== null && (typeof n == "object" || typeof n == "function");
}
function Xt(n) {
  if (!To(n))
    throw new TypeError(Oa);
  return n;
}
const Ce = zt, Kt = (n) => `Missing ${n}`, mi = (n) => "No valid fields: " + n.join(), ka = "Invalid bag", hi = (n, t, e) => zt(n, t) + "; must be " + Object.keys(e).join(), Ra = "Cannot use valueOf", Aa = "Invalid calling context", Ze = (n) => "Missing year" + (n ? "/era/eraYear" : ""), tt = "Invalid leap month", xa = (n) => zt("Calendar", n), ja = (n, t) => `Unknown calendar ${n}; might need ${t}`, yi = (n) => zt("TimeZone", n), jn = "Out-of-bounds date", pi = (n) => `Cannot parse: ${n}`, Cn = (n) => `Invalid substring: ${n}`, Do = Ya, nn = To;
function h(n) {
  throw new RangeError(n);
}
function S(n) {
  throw new TypeError(n);
}
function uo(n, t, e, o, r) {
  return vn(t, ((i, c) => {
    const a = i[c];
    return a === void 0 && S(Kt(c)), a;
  })(n, t), e, o, r);
}
function vn(n, t, e, o, r, i) {
  const c = Do(t, e, o);
  return r && t !== c && h(((a, s, u, d, f) => f ? Rr(a, f[s], f[u], f[d]) : Rr(a, s, u, d))(n, t, e, o, i)), c;
}
function Nt(n, t = Map) {
  const e = new t();
  return (o, ...r) => {
    if (e.has(o))
      return e.get(o);
    const i = n(o, ...r);
    return e.set(o, i), i;
  };
}
const Ua = (n) => So({
  name: n
}, 1), So = (n, t) => St((e) => ({
  value: e,
  configurable: 1,
  writable: !t
}), n), bo = (n) => ({
  [Symbol.toStringTag]: {
    value: n,
    configurable: 1
  }
});
function St(n, t) {
  const e = {};
  for (const o in t)
    e[o] = n(t[o], o);
  return e;
}
function Qt(n, t) {
  const e = {};
  for (const o of n)
    e[o] = t;
  return e;
}
function Fo(n) {
  const t = {};
  for (const e of n)
    t[e] = (o) => o[e];
  return t;
}
function Mn(n, t, e = /* @__PURE__ */ Object.create(null)) {
  for (const o of n)
    e[o] = t[o];
  return e;
}
function gi(n, t, e) {
  for (const o of n)
    if (t[o] !== e[o])
      return 0;
  return 1;
}
function La(n, t, e) {
  const o = {
    ...e
  };
  for (let r = 0; r < t; r++)
    o[n[r]] = 0;
  return o;
}
function Y(n, ...t) {
  return (...e) => n(...t, ...e);
}
function xr() {
}
function jr(n) {
  return n[0].toUpperCase() + n.substring(1);
}
function k(...n) {
  return [].concat(...n).sort();
}
function bt(n) {
  return new RegExp(`^${n}$`, "i");
}
function Oo(n) {
  return parseInt(n.padEnd(9, "0"));
}
function Po(n) {
  return n && n !== "+" ? -1 : 1;
}
function vt(n) {
  return n === void 0 ? 0 : parseInt(n);
}
function Ne(n, t) {
  return String(t).padStart(n, "0");
}
const dn = /* @__PURE__ */ Y(Ne, 2);
function Zn(n, t) {
  return Math.sign(n - t);
}
function C(n, t) {
  return n < t ? -1 : n > t ? 1 : 0;
}
function Ii(n, t) {
  const e = n / t;
  return n % t < 0n ? e - 1n : e;
}
function Co(n, t) {
  const e = Ii(n, t);
  return [e, n - e * t];
}
function gn(n, t) {
  return [Math.floor(n / t), Ee(n, t)];
}
function Ee(n, t) {
  return (n % t + t) % t;
}
function Ft(n, t) {
  return Math.trunc(n / t) || 0;
}
function Zo(n, t) {
  return n % t || 0;
}
function vi(n, t = 1) {
  return t * (0.5 + n / 5);
}
function Ie(n) {
  return Math.abs(n % 1) === 0.5;
}
const Mi = "iso8601", Wa = "gregory", $a = {
  bce: -1,
  ce: 0
};
function Ni(n) {
  const t = n.normalize("NFD").toLowerCase().replace(/[^a-z0-9]/g, "");
  return t === "bc" || t === "b" ? "bce" : t === "ad" || t === "a" ? "ce" : t;
}
const fn = void 0, qa = 0;
function Nn(n) {
  return n === fn ? "iso8601" : n === 0 ? "gregory" : n.id;
}
const _a = /^M(\d{2})(L?)$/;
function Ti(n) {
  const t = _a.exec(n);
  return t || h(((e) => `Invalid monthCode: ${e}`)(n)), [parseInt(t[1]), !!t[2]];
}
function Di(n, t) {
  return "M" + dn(n) + (t ? "L" : "");
}
function fo(n, t, e) {
  return n + (t || e && n >= e ? 1 : 0);
}
const lo = {
  nanosecond: 0,
  microsecond: 1,
  millisecond: 2,
  second: 3,
  minute: 4,
  hour: 5,
  day: 6,
  week: 7,
  month: 8,
  year: 9
}, Eo = /* @__PURE__ */ Object.keys(lo), ne = Pa, te = Ca, qn = Za, ee = Ea, oe = wa, Bn = 864e11, ln = [1, ne, te, qn, ee, oe, Bn], Ga = /* @__PURE__ */ BigInt(ne), we = /* @__PURE__ */ BigInt(te), ot = /* @__PURE__ */ BigInt(qn), Va = /* @__PURE__ */ BigInt(ee), Ha = /* @__PURE__ */ BigInt(oe), O = /* @__PURE__ */ BigInt(Bn);
function Si(n, t) {
  const e = Number(n / O), o = Number(n % O);
  return e * (Bn / t) + (Math.trunc(o / t) + o % t / t);
}
const $ = /* @__PURE__ */ Eo.slice(0, 6), wo = /* @__PURE__ */ Fo($), Be = ["year"], ct = ["day"], Bo = ["day", "month", "year"], Ye = ["offset"], Yo = ["timeZone"], Ot = ["era", "eraYear"], Ja = ["era", "eraYear", "year"], bi = ["month", "monthCode"], za = ["day", "month", "monthCode"], mo = /* @__PURE__ */ k($), Xa = /* @__PURE__ */ k(Ot, Be), re = /* @__PURE__ */ k(bi, Be), Fi = /* @__PURE__ */ k(Ot, re), ie = /* @__PURE__ */ k(["monthCode"], Be), Oi = /* @__PURE__ */ k(Ot, ie), Pi = /* @__PURE__ */ k(ct, ["monthCode"]), at = /* @__PURE__ */ k(ct, re), st = /* @__PURE__ */ k(ct, Ot, re), Ci = /* @__PURE__ */ k(at, $), Zi = /* @__PURE__ */ k(st, $), Ka = /* @__PURE__ */ k(at, $, Ye), Qa = /* @__PURE__ */ k(st, $, Ye), Ei = /* @__PURE__ */ k(at, $, Ye, Yo), wi = /* @__PURE__ */ k(st, $, Ye, Yo), ns = /* @__PURE__ */ k(ct, ie), ts = /* @__PURE__ */ k(ct, Ot, ie), mn = /* @__PURE__ */ Qt($, 0);
function ke(n) {
  return Re(n, 1), n;
}
const es = {
  hour: 23,
  minute: 59,
  second: 59
};
function Re(n, t) {
  const e = {};
  for (const o of $)
    e[o] = vn(o, n[o], 0, es[o] || 999, t);
  return e;
}
function K(n) {
  return ko(n) * qn + Yi(n);
}
function Bi(n) {
  return 1e3 * ko(n) + n.millisecond;
}
function ko(n) {
  return 3600 * n.hour + 60 * n.minute + n.second;
}
function Yi(n) {
  return n.millisecond * te + n.microsecond * ne + n.nanosecond;
}
function Ro(n) {
  const [t, e] = gn(n, Bn);
  return [ki(e), t];
}
function ki(n) {
  const [t, e] = gn(n, te), [o, r] = gn(e, ne);
  return os(t, o, r);
}
function os(n, t = 0, e = 0) {
  const [o, r] = gn(n, 36e5), [i, c] = gn(r, 6e4), [a, s] = gn(c, 1e3);
  return {
    hour: o,
    minute: i,
    second: a,
    millisecond: s,
    microsecond: t,
    nanosecond: e
  };
}
function Ur(n) {
  const [t, e] = Co(n, ot);
  return [Number(t), Number(e)];
}
function In(n) {
  return et(n) + BigInt(K(n));
}
function rs(n) {
  return Ae(n) + Bi(n);
}
function et(n) {
  return BigInt(Tn(n)) * O;
}
function Ae(n) {
  return 864e5 * Tn(n);
}
function Tn(n) {
  return Wt(n.year, n.month, n.day);
}
function Wt(n, t = 1, e = 1) {
  const o = t - 1;
  return n += Math.floor(o / 12), t = Ee(o, 12), Date.UTC(n % 400 - 400, t, 0) / 864e5 + 146097 * (Ft(n, 400) + 1) + e;
}
function ce(n) {
  const [t, e] = Co(n, O);
  return {
    ...Ri(Number(t)),
    ...ki(Number(e))
  };
}
function Ri(n) {
  const t = new Date(864e5 * Ee(n, 146097));
  return {
    year: t.getUTCFullYear() + 400 * Math.floor(n / 146097),
    month: t.getUTCMonth() + 1,
    day: t.getUTCDate()
  };
}
const is = 1972;
function cs(n) {
  return [n, 0];
}
function ho(n, t) {
  if (!t)
    return {
      year: 1972,
      month: n
    };
}
function as(n, t, e) {
  return {
    year: n,
    month: t,
    day: e
  };
}
function Ai(n, t) {
  switch (t) {
    case 2:
      return xe(n) ? 29 : 28;
    case 4:
    case 6:
    case 9:
    case 11:
      return 30;
  }
  return 31;
}
function ss(n) {
  return xe(n) ? 366 : 365;
}
function xe(n) {
  return n % 4 == 0 && (n % 100 != 0 || n % 400 == 0);
}
function xi(n, t, e) {
  return n += Ft(e, 12), (t += Zo(e, 12)) < 1 ? (n--, t += 12) : t > 12 && (n++, t -= 12), {
    year: n,
    month: t
  };
}
function us(n, t, e, o) {
  return 12 * (e - n) + o - t;
}
function Ao(n) {
  return Ee(Wt(n.year, n.month, n.day) + 4, 7) || 7;
}
function ji(n) {
  return Wt(n.year, n.month, n.day) - Wt(n.year) + 1;
}
function Ui(n) {
  let t = n.year, e = Math.floor((ji(n) - Ao(n) + 10) / 7), o = ro(t);
  return e < 1 ? e = o = ro(--t) : e > o && (e = 1, o = ro(++t)), {
    weekOfYear: e,
    yearOfWeek: t,
    Ie: o
  };
}
function ro(n) {
  const t = Ao({
    year: n,
    month: 1,
    day: 1
  });
  return t === 4 || t === 3 && xe(n) ? 53 : 52;
}
function ds({ year: n }) {
  return n < 1 ? {
    era: "bce",
    eraYear: 1 - n
  } : {
    era: "ce",
    eraYear: n
  };
}
function je(n) {
  return _n(n), ke(n);
}
function _n(n) {
  return Li(n, 1), n;
}
function Lr(n) {
  return gi(Bo, n, Li(n));
}
function Li(n, t) {
  const { year: e } = n, o = uo(n, "month", 1, 12, t);
  return {
    year: e,
    month: o,
    day: uo(n, "day", 1, Ai(e, o), t)
  };
}
function F(n, t) {
  return n ? n.ie(t) : t;
}
function rt(n, t, e) {
  return n ? n.O(t, e) : cs(e);
}
function Te(n, t) {
  return n === 0 ? ds(t) : n ? n.h(t) : {};
}
function it(n, t, e, o) {
  return n ? n.je(t, e, o) : as(t, e, o);
}
function $t(n, t) {
  return n ? n.k(t) : 12;
}
function qt(n, t, e) {
  return n ? n.p(t, e) : Ai(t, e);
}
function xo(n, t) {
  const { year: e, month: o } = F(n, t), [r, i] = rt(n, e, o);
  return Di(r, i);
}
function Wi(n, t) {
  const { year: e } = F(n, t);
  return n ? n.u(e) : xe(e);
}
function $i(n, t) {
  const { year: e } = F(n, t);
  return $t(n, e);
}
function qi(n, t) {
  const { year: e, month: o } = F(n, t);
  return qt(n, e, o);
}
function _i(n, t) {
  const { year: e } = F(n, t);
  return n ? n.j(e) : ss(e);
}
function fs(n, t) {
  if (!n)
    return ji(t);
  const { year: e } = F(n, t), o = it(n, e, 1, 1);
  return Tn(t) - Tn(o) + 1;
}
function ls(n, t) {
  return n === fn ? Ui(t).weekOfYear : void 0;
}
function ms(n, t) {
  return n === fn ? Ui(t).yearOfWeek : void 0;
}
const P = /* @__PURE__ */ Eo.map((n) => n + "s"), hs = /* @__PURE__ */ Fo(P), Gi = /* @__PURE__ */ k(P), ys = /* @__PURE__ */ P.slice(0, 6), Vi = /* @__PURE__ */ P.slice(6), ps = /* @__PURE__ */ Vi.slice(1), gs = /* @__PURE__ */ P.reduce((n, t, e) => (n[t] = e, n), {}), B = /* @__PURE__ */ Qt(P, 0), jo = /* @__PURE__ */ Qt(ys, 0), Uo = /* @__PURE__ */ Y(La, P);
function Hi(n, t) {
  return t == null && h(Kt(n)), t;
}
const W = /* @__PURE__ */ Y(Is, "string");
function Is(n, t, e = n) {
  return typeof t !== n && S(Ce(e, t)), t;
}
function vs(n, t = "number") {
  return Number.isInteger(n) || h(((e, o) => `Non-integer ${e}: ${o}`)(t, n)), n || 0;
}
function Lo(n) {
  return typeof n == "symbol" && S("Cannot convert Symbol to string"), String(n);
}
function Wo(n, t) {
  return To(n) ? String(n) : W(n, t);
}
function $o(n) {
  return typeof n == "boolean" ? BigInt(n ? 1 : 0) : typeof n == "string" ? BigInt(n) : (typeof n != "bigint" && S(`Invalid bigint: ${n}`), n);
}
function qo(n, t) {
  return vs(li(n, t), t);
}
function Ue(n, t) {
  return typeof n == "string" ? ((e, o) => {
    const r = /* @__PURE__ */ Object.create(null);
    return r[e] = o, r;
  })(t, n) : Xt(n);
}
const En = "smallestUnit", Ms = {
  constrain: 0,
  reject: 1
}, Ns = {
  compatible: 0,
  reject: 1,
  earlier: 2,
  later: 3
}, Ts = {
  reject: 0,
  use: 1,
  prefer: 2,
  ignore: 3
}, Ds = {
  auto: 0,
  never: 1,
  critical: 2,
  always: 3
}, Ss = {
  auto: 0,
  never: 1,
  critical: 2
}, bs = {
  auto: 0,
  never: 1
}, Fs = {
  floor: 0,
  halfFloor: 1,
  ceil: 2,
  halfCeil: 3,
  trunc: 4,
  halfTrunc: 5,
  expand: 6,
  halfExpand: 7,
  halfEven: 8
}, Os = [Math.floor, (n) => Ie(n) ? Math.floor(n) : Math.round(n), Math.ceil, (n) => Ie(n) ? Math.ceil(n) : Math.round(n), Math.trunc, (n) => Ie(n) ? Math.trunc(n) || 0 : Math.round(n), (n) => n < 0 ? Math.floor(n) : Math.ceil(n), (n) => Math.sign(n) * Math.round(Math.abs(n)) || 0, (n) => Ie(n) ? (n = Math.trunc(n) || 0) + n % 2 : Math.round(n)], Ps = {
  previous: -1,
  next: 1
};
function _o(n) {
  const t = n.roundingIncrement;
  return t === void 0 ? 1 : J(t, "roundingIncrement");
}
function Go(n) {
  let t = n.fractionalSecondDigits;
  if (t !== void 0) {
    if (typeof t != "number") {
      if (Lo(t) === "auto")
        return;
      h(Ce("fractionalSecondDigits", t));
    }
    t = vn("fractionalSecondDigits", Math.floor(t), 0, 9, 1);
  }
  return t;
}
function Vo(n, t, e = 0, o) {
  let r = t[n];
  if (r === void 0)
    return o ? e : void 0;
  if (r = Lo(r), r === "auto")
    return o ? e : null;
  let i = lo[r];
  return i === void 0 && (i = gs[r]), i === void 0 && h(hi(n, r, lo)), i;
}
function Gn(n, t, e, o = 0) {
  const r = e[n];
  if (r === void 0)
    return o;
  const i = Lo(r), c = t[i];
  return c === void 0 && h(hi(n, i, t)), c;
}
const Pt = /* @__PURE__ */ Y(Vo, En), Ji = /* @__PURE__ */ Y(Vo, "largestUnit"), Cs = /* @__PURE__ */ Y(Vo, "unit"), zi = /* @__PURE__ */ Y(Gn, "overflow", Ms), Xi = /* @__PURE__ */ Y(Gn, "disambiguation", Ns), Zs = /* @__PURE__ */ Y(Gn, "offset", Ts), Ho = /* @__PURE__ */ Y(Gn, "calendarName", Ds), Es = /* @__PURE__ */ Y(Gn, "timeZoneName", Ss), ws = /* @__PURE__ */ Y(Gn, "offset", bs), Ct = /* @__PURE__ */ Y(Gn, "roundingMode", Fs), Bs = /* @__PURE__ */ Y(Gn, "direction", Ps);
function Jo(n, t, e, o) {
  const r = o ? Bn : ln[t + 1];
  if (r) {
    const i = ln[t];
    r % ((n = vn("roundingIncrement", n, 1, r / i - (o ? 0 : 1), 1)) * i) && h(Ce("roundingIncrement", n));
  } else
    n = vn("roundingIncrement", n, 1, e ? 10 ** 9 : 1, 1);
  return n;
}
function Tt(n, t, e, o) {
  return t != null && vn(n, t, e, o, 1, Eo), t;
}
function Ki(n, t) {
  t > n && h("smallestUnit > largestUnit");
}
function Zt(n, t, e, o = 9, r = 0, i = 4) {
  t = Dn(t);
  let c = Ji(t, r), a = _o(t), s = Ct(t, i), u = Pt(t, r, 1);
  return c = Tt("largestUnit", c, r, o), u = Tt(En, u, r, o), c == null ? c = Math.max(e, u) : Ki(c, u), a = Jo(a, u, 1), n && (s = ((d) => d < 4 ? (d + 2) % 4 : d)(s)), [c, u, a, s];
}
function Le(n, t = 6, e) {
  let o = _o(n = Ue(n, En));
  const r = Ct(n, 7);
  let i = Pt(n);
  return i = Hi(En, i), i = Tt(En, i, 0, t), o = Jo(o, i, void 0, e), [i, o, r];
}
function Z(n, t) {
  return Mn(Bo, n, Mn($, t));
}
function T(n) {
  return n === void 0 ? 0 : zi(Xt(n));
}
function _t(n, t = 0) {
  n = Dn(n);
  const e = Xi(n), o = Zs(n, t);
  return [zi(n), o, e];
}
const Qi = /* @__PURE__ */ BigInt(1e8) * O, zo = /* @__PURE__ */ BigInt(-1e8) * O, nc = zo - O, tc = -3261848;
function Xo(n) {
  const t = 12 * n.year + n.month;
  return (t < tc || t > 3309129) && h(jn), n;
}
function Q(n, t = 1) {
  return ec(et(n), t), n;
}
function Et(n) {
  const t = et(n);
  return ec(t), t !== nc || K(n) || h(jn), n;
}
function ec(n, t = 1) {
  (n < (t ? nc : zo) || n > Qi) && h(jn);
}
function Sn(n) {
  return (n < zo || n > Qi) && h(jn), n;
}
function Ko(n, t) {
  return Sn(et(n) + BigInt(K(n) - t));
}
function pn(n) {
  return {
    epochNanoseconds: n
  };
}
function bn(n, t, e) {
  return {
    calendar: e,
    timeZone: t,
    epochNanoseconds: n
  };
}
function Pn(n, t) {
  return Mn($, n, b(n, t));
}
function b(n, t) {
  return Mn(Bo, n, {
    calendar: t
  });
}
function wt(n) {
  return Mn($, n);
}
function x(n) {
  return Mn(P, n, {
    sign: He(n)
  });
}
function De(n) {
  return t = n.epochNanoseconds, Number(Ii(t, we));
  var t;
}
function We(n) {
  return n.epochNanoseconds;
}
function Ys(n, t, e) {
  const o = $n(t), [r, i] = ((u, d) => {
    const f = d((u = Ue(u, "unit")).relativeTo);
    let l = Cs(u);
    return l = Hi("unit", l), [l, f];
  })(e, n);
  if (!i && Mt(Math.max(r, o), i))
    return Wr(t, r);
  if (i || h("Missing relativeTo"), !t.sign && Mt(r, i))
    return 0;
  const c = Ve(i), a = c.G(c.i, t);
  dc(c, a);
  const s = c.re(c.i, a, r);
  return Mt(r, i) ? Wr(s, r) : ks(s, c.V(a), r, c);
}
function ks(n, t, e, o) {
  const r = He(n) || 1, i = Qo(Uo(e, n), e, r, o, t), c = i.ae, a = i.de, s = Number(a - c), u = Number(t - c);
  return i.ye[P[e]] + u / s * r;
}
function Wr(n, t) {
  return Si(wn(n), ln[t]);
}
function Qo(n, t, e, o, r) {
  const i = P[t];
  let c = n, a = 0, s = $r(c, i, e, o);
  return r && !((u, d, f, l) => l > 0 ? C(d, u) <= 0 && C(u, f) <= 0 : C(f, u) <= 0 && C(u, d) <= 0)(r, s.ae, s.de, Math.sign(e)) && (c = {
    ...n,
    [i]: n[i] + e
  }, a = 1, s = $r(c, i, e, o)), {
    ...s,
    ye: c,
    He: a
  };
}
function $r(n, t, e, o) {
  const r = {
    ...n,
    [t]: n[t] + e
  };
  return {
    ae: Ht(o, n),
    de: Ht(o, r),
    Ae: r
  };
}
function oc(n, t, e) {
  const o = e - t, r = n - t;
  if (!r)
    return 0;
  const i = r < 0n ? -r : r, c = o < 0n ? -o : o, a = C(r, 0n) === C(o, 0n) ? 1 : -1;
  return C(i, c) <= 0 ? i === c ? a : vi(C(2n * i, c), a) : Number(r) / Number(o);
}
function Rs(n, t, e, o) {
  let { epochNanoseconds: r } = n;
  const { timeZone: i, calendar: c } = n;
  if (t === 0 && e === 1)
    return {
      epochNanoseconds: r,
      timeZone: i,
      calendar: c
    };
  if (t === 6) {
    const a = Z(j(n), mn), s = Z(Vn(a, 1), mn), u = Un(i, a), d = Un(i, s);
    r = or(oc(r, u, d), o) ? d : u;
  } else {
    const a = j(n), s = a.offsetNanoseconds;
    r = Bt(i, nr(a, ae(t, e), o), s, 2, 0, 1);
  }
  return {
    epochNanoseconds: r,
    timeZone: i,
    calendar: c
  };
}
function As(n) {
  const { timeZone: t } = n, e = Z(j(n), mn), o = Z(Vn(e, 1), mn), r = Un(t, e);
  return Si(Un(t, o) - r, oe);
}
function xs(n) {
  const { timeZone: t, calendar: e } = n;
  return bn(Un(t, Z(j(n), mn)), t, e);
}
function nr(n, t, e) {
  const [o, r] = tr(n, t, e), i = Z(Vn(n, r), o);
  return Et(i), i;
}
function tr(n, t, e) {
  return Ro(Dt(K(n), t, e));
}
function Se(n) {
  return Dt(n, ee, 7);
}
function ae(n, t) {
  return ln[n] * t;
}
function $e(n, t) {
  return BigInt(ln[n]) * BigInt(t);
}
function js(n, t, e) {
  const o = Math.min($n(n), 6);
  return Wn(_e(wn(n), BigInt(t), e), o);
}
function qe(n, t, e, o, r, i, c) {
  if (o === 0 && r === 1)
    return n;
  const a = He(n) || 1, s = Mt(o, c.i) ? ue(c.i) && o < 6 && e >= 6 ? Ls : Us : Ws;
  let [u, d, f] = s(a, n, t, e, o, r, i, c);
  return f && o !== 7 && (u = ((l, m, p, y, g, I) => {
    for (let v = y + 1; v <= p; v++) {
      if (v === 7 && p !== 7)
        continue;
      const D = Uo(v, l);
      D[P[v]] += g;
      const M = C(m, Ht(I, D));
      if (M && M !== g)
        break;
      l = D;
    }
    return l;
  })(u, d, e, Math.max(6, o), a, c)), u;
}
function _e(n, t, e) {
  return rc(n, t, e, n / t % 2n);
}
function er(n, t, e) {
  const [o, r] = Co(n, O), i = o * O;
  return i + rc(r, t, e, (i / t + r / t) % 2n);
}
function rc(n, t, e, o) {
  const r = n / t, i = n % t;
  let c = 0;
  i && (c = vi(C(2n * (i < 0n ? -i : i), t), Math.sign(Number(i))));
  const a = or(Number(o) + c, e);
  return (r - o + BigInt(a)) * t;
}
function Dt(n, t, e) {
  return or(n / t, e) * t;
}
function or(n, t) {
  return Os[t](n);
}
function Us(n, t, e, o, r, i, c) {
  const a = wn(t), s = _e(a, $e(r, i), c), u = s - a, d = Math.sign(Number(s / O) - Number(a / O)) === n, f = Wn(s, Math.min(o, 6));
  return [{
    ...t,
    ...f
  }, e + u, d];
}
function Ls(n, t, e, o, r, i, c, a) {
  const s = Number(dt(t)), u = ae(r, i);
  let d = Dt(s, u, c);
  const f = Qo({
    ...t,
    ...jo
  }, 6, n, a, e), l = f.ae, m = f.de, p = d - Number(m - l);
  let y = 0;
  p && Math.sign(p) !== n ? e = l + BigInt(d) : (y += n, d = Dt(p, u, c), e = m + BigInt(d));
  const g = Je(d);
  return [{
    ...t,
    ...g,
    days: t.days + y
  }, e, !!y];
}
function Ws(n, t, e, o, r, i, c, a) {
  const s = P[r], u = Uo(r, t);
  r === 7 && (t = {
    ...t,
    weeks: t.weeks + Math.trunc(t.days / 7)
  });
  const d = Ft(t[s], i) * i;
  u[s] = d;
  const f = Qo(u, r, i * n, a, e), l = f.ae, m = f.de, p = oc(e, l, m), y = f.ye[s], g = f.Ae[s], I = Dt(y + p * n * i, i, c), v = I === g;
  return u[s] = I, [u, v ? m : l, f.He || v];
}
function $s(n, t) {
  return n.timeZone.U(n.epochNanoseconds, ((e) => {
    const o = Ue(e, "direction"), r = Bs(o, 0);
    return r || h(Ce("direction", r)), r;
  })(t));
}
const j = /* @__PURE__ */ Nt(qs, WeakMap);
function qs(n) {
  const { epochNanoseconds: t, timeZone: e } = n, o = e.C(t);
  return {
    ...ce(t + BigInt(o)),
    offsetNanoseconds: o
  };
}
function Bt(n, t, e, o = 0, r = 0, i, c) {
  if (e !== void 0 && o === 1 && (o === 1 || c))
    return Ko(t, e);
  o !== 2 && o !== 0 || Q(t, 0);
  const a = n.R(t);
  if (e !== void 0 && o !== 3) {
    const s = ((u, d, f, l) => {
      const m = In(d);
      l && (f = Se(f));
      for (const p of u) {
        let y = Number(m - p);
        if (l && (y = Se(y)), y === f)
          return p;
      }
    })(a, t, e, i);
    if (s !== void 0)
      return s;
    o === 0 && h("Invalid TimeZone offset");
  }
  return c ? In(t) : se(n, t, r, a);
}
function se(n, t, e = 0, o = n.R(t)) {
  if (o.length === 1)
    return o[0];
  if (e === 1 && h("Ambiguous offset"), o.length)
    return o[e === 3 ? 1 : 0];
  const r = In(t), i = ((a, s) => {
    const u = a.C(s - O);
    return ((d) => (d > Bn && h("Out-of-bounds TimeZone gap"), d))(a.C(s + O) - u);
  })(n, r), c = ce(r + BigInt(i * (e === 2 ? -1 : 1)));
  return (o = n.R(c))[e === 2 ? 0 : o.length - 1];
}
function Un(n, t) {
  const e = n.R(t);
  if (e.length)
    return e[0];
  const o = In(t) - O;
  return n.U(o, 1);
}
function qr(n, t, e, o, r) {
  const i = T(r);
  o.sign && $n(o) < 8 && h("Cannot use small units");
  const c = Q(Vt(t, e));
  return Vt(t, ic(t, c, n ? q(o) : o, i));
}
function _r(n, t) {
  return Sn(n + (yc(e = t) && h("Cannot use large units"), dt(e)));
  var e;
}
function be(n, t, e) {
  const { calendar: o, epochNanoseconds: r, timeZone: i } = n, c = dt(t);
  let a = r;
  if (yc(t)) {
    const s = j(n);
    a = se(i, Z(Gt(o, s, {
      ...t,
      ...jo
    }, e), s)) + c;
  } else
    a += c, T(e);
  return {
    ...n,
    epochNanoseconds: Sn(a)
  };
}
function Fe(n, t, e, o) {
  const [r, i] = yo(t, e), c = Z(Gt(n, t, {
    ...e,
    ...jo,
    days: e.days + i
  }, o), r);
  return Et(c), c;
}
function Gt(n, t, e, o) {
  if (e.years || e.months || e.weeks)
    return ic(n, t, e, T(o));
  T(o);
  const r = e.days + Number(dt(e) / O);
  return r ? Q(Vn(t, r)) : t;
}
function Vt(n, t) {
  return Vn(t, 1 - F(n, t).day);
}
function yo(n, t) {
  const e = dt(t), o = Number(e / O), r = Number(e % O), [i, c] = Ro(K(n) + r);
  return [i, o + c];
}
function Vn(n, t) {
  return t ? Ri(Tn(n) + t) : n;
}
function ic(n, t, e, o) {
  let { years: r, months: i, weeks: c, days: a } = e, s;
  if (a += Number(dt(e) / O), r || i)
    s = po(n, t, r, i, o);
  else {
    if (!c && !a)
      return t;
    s = t;
  }
  return (c || a) && (s = Vn(s, 7 * c + a)), Q(s);
}
function po(n, t, e, o, r) {
  const i = F(n, t);
  let { year: c, month: a, day: s } = i;
  if (e) {
    const [u, d] = rt(n, c, a);
    c += e, a = go(n, u, d, n ? n.q(c) : void 0, r), a = vn("month", a, 1, $t(n, c), r);
  }
  return o && ({ year: c, month: a } = n ? n.N(c, a, o) : xi(c, a, o)), s = vn("day", s, 1, qt(n, c, a), r), it(n, c, a, s);
}
function go(n, t, e, o, r) {
  if (e) {
    const i = n ? n.m : void 0;
    return o !== void 0 && (i < 0 || o === t + 1) ? o : (r === 1 && h(tt), i < 0 ? -i : t);
  }
  return fo(t, 0, o);
}
function Ln(n, t) {
  return Nn(n) !== Nn(t) && h("Mismatching Calendars"), n;
}
function _s(n, t) {
  return n.o !== t.o && h("Mismatching TimeZones"), n;
}
function Gs(n) {
  return n.timeZone.id;
}
function Gr(n, t, e, o) {
  const [r, i, c, a] = Zt(n, o, 3, 5), s = Ge(t.epochNanoseconds, e.epochNanoseconds, r, i, c, a);
  return x(n ? q(s) : s);
}
function Vr(n, t, e, o, r) {
  const [i, c, a, s] = Zt(n, r, 5), u = e.epochNanoseconds, d = o.epochNanoseconds;
  let f;
  return C(d, u) ? i < 6 ? f = Ge(u, d, i, c, a, s) : (f = ac(_s(e.timeZone, o.timeZone), t, e, o, i), f = qe(f, d, i, c, a, s, ir(e, We, be))) : f = B, x(n ? q(f) : f);
}
function Hr(n, t, e, o, r) {
  const [i, c, a, s] = Zt(n, r, 6), u = In(e), d = In(o), f = C(d, u);
  let l;
  return f ? i <= 6 ? l = Ge(u, d, i, c, a, s) : (l = sc(t, e, o, f, i), l = qe(l, d, i, c, a, s, ir(e, In, Y(Fe, t)))) : l = B, x(n ? q(l) : l);
}
function Jr(n, t, e, o, r) {
  const [i, c, a, s] = Zt(n, r, 6, 9, 6);
  return cc(n, t, e, o, i, c, a, s);
}
function zr(n, t, e, o, r) {
  const [i, c, a, s] = Zt(n, r, 9, 9, 8), u = Vt(t, e), d = Vt(t, o);
  return uc(u, d) ? cc(n, t, Q(u), Q(d), i, c, a, s, 8) : x(B);
}
function cc(n, t, e, o, r, i, c, a, s = 6) {
  const u = et(e), d = et(o);
  let f;
  return C(d, u) ? r === 6 ? f = Ge(u, d, r, i, c, a) : (f = rr(t, e, o, r), i === s && c === 1 || (f = qe(f, d, r, i, c, a, ir(e, et, Y(Gt, t))))) : f = B, x(n ? q(f) : f);
}
function Xr(n, t, e, o) {
  const [r, i, c, a] = Zt(n, o, 5, 5), s = Dt(K(e) - K(t), ae(i, c), a), u = {
    ...B,
    ...Je(s, r)
  };
  return x(n ? q(u) : u);
}
function ac(n, t, e, o, r) {
  const i = C(o.epochNanoseconds, e.epochNanoseconds);
  if (!i)
    return B;
  if (r < 6)
    return {
      ...B,
      ...Wn(o.epochNanoseconds - e.epochNanoseconds, r)
    };
  if (!uc(j(e), j(o)))
    return {
      ...B,
      ...Wn(o.epochNanoseconds - e.epochNanoseconds, 5)
    };
  const [c, a, s] = Hs(n, e, o, i);
  return {
    ...r === 6 ? {
      ...B,
      days: Me(c, a)
    } : rr(t, c, a, r),
    ...Je(s)
  };
}
function Vs(n, t, e, o) {
  const r = In(t), i = In(e), c = C(i, r);
  return c ? o <= 6 ? {
    ...B,
    ...Wn(i - r, o)
  } : sc(n, t, e, c, o) : B;
}
function sc(n, t, e, o, r) {
  let i = e, c = K(e) - K(t);
  return Math.sign(c) === -o && (i = Vn(e, -o), c += Bn * o), {
    ...rr(n, t, i, r),
    ...Je(c)
  };
}
function rr(n, t, e, o) {
  if (o <= 7) {
    const y = Me(t, e);
    return o === 7 ? {
      ...B,
      weeks: Ft(y, 7),
      days: Zo(y, 7)
    } : {
      ...B,
      days: y
    };
  }
  const r = F(n, t), i = F(n, e);
  if (o === 8) {
    const { year: y, month: g, day: I } = r, { year: v, month: D, day: M } = i, an = Math.sign(Zn(v, y) || Zn(D, g) || Me(t, e));
    let G = 0, sn = 0;
    if (an) {
      G = n ? n.ne(y, g, v, D) : us(y, g, v, D);
      let V = po(n, t, 0, G, 0);
      an * Zn(I, M) > 0 && (G -= an, V = po(n, t, 0, G, 0)), sn = Me(V, e);
    }
    return {
      ...B,
      months: G,
      days: sn
    };
  }
  const { year: c, month: a, day: s } = r;
  let { year: u, month: d, day: f } = i, l = u - c, m = d - a, p = f - s;
  if (l || m) {
    const y = Math.sign(l || m);
    let g = qt(n, u, d), I = 0;
    if (Math.sign(f - s) === -y) {
      const v = g;
      ({ year: u, month: d } = n ? n.N(u, d, -y) : xi(u, d, -y)), l = u - c, m = d - a, g = qt(n, u, d), I = y < 0 ? -v : g;
    }
    if (p = f - Math.min(s, g) + I, l) {
      const [v, D] = rt(n, c, a), [M, an] = rt(n, u, d), G = n ? n.m : void 0;
      if (m = G !== void 0 && D && !an && (G < 0 ? y > 0 && M === -G : y < 0 && M === v) ? 0 : M - v || Number(an) - Number(D), Math.sign(m) === -y) {
        const sn = y < 0 && -$t(n, u);
        u -= y, l = u - c, m = d - go(n, v, D, n ? n.q(u) : void 0, 0) + (sn || $t(n, u));
      } else if (n) {
        const sn = go(n, v, D, n.q(u), 0);
        m = n.ne(u, sn, u, d);
      }
    }
  }
  return {
    ...B,
    years: l,
    months: m,
    days: p
  };
}
function uc(n, t) {
  return Zn(n.year, t.year) || Zn(n.month, t.month) || Zn(n.day, t.day);
}
function Hs(n, t, e, o) {
  const r = j(t), i = j(e), c = e.epochNanoseconds;
  let a = 0;
  const s = K(i) - K(r);
  Math.sign(s) === -o && a++;
  const u = a + (o > 0 ? 1 : 0);
  for (; a <= u; a++) {
    const d = Vn(i, a * -o), f = se(n, Z(d, r));
    if (C(c, f) !== -o)
      return [r, d, Number(c - f)];
  }
}
function Ge(n, t, e, o, r, i) {
  return {
    ...B,
    ...Wn(_e(t - n, $e(o, r), i), e)
  };
}
function Me(n, t) {
  return Tn(t) - Tn(n);
}
function ir(n, t, e) {
  return {
    i: n,
    V: t,
    G: e
  };
}
function Ve(n) {
  const { calendar: t } = n;
  if (ue(n)) {
    const { timeZone: e } = n;
    return {
      i: n,
      V: We,
      G: be,
      re: Y(ac, e, t)
    };
  }
  return {
    i: fc(n),
    V: In,
    G: Y(Fe, t),
    re: Y(Vs, t)
  };
}
function Ht(n, t) {
  return n.V(n.G(n.i, t));
}
function ue(n) {
  return "timeZone" in n;
}
function dc(n, t) {
  ue(n.i) || (Kr(n.i), Kr(t));
}
function fc(n) {
  return Z(n, "hour" in n ? n : mn);
}
function Kr(n) {
  Et(fc(n));
}
function Mt(n, t) {
  return n <= 6 - (t && ue(t) ? 1 : 0);
}
function cr(n, t, e) {
  const o = {};
  for (let r = t; r >= 0; r--) {
    const i = ln[r];
    o[e[r]] = Ft(n, i), n = Zo(n, i);
  }
  return o;
}
const Js = 2 ** 53;
function Qr(n, t, e, o, r) {
  const i = n(Dn(r).relativeTo), c = Math.max($n(e), $n(o));
  if (Mt(c, i))
    return zs(t, e, o, c);
  i || h("Missing relativeTo"), t && (o = q(o));
  const a = Ve(i), s = a.G(a.i, e), u = a.G(s, o);
  return x(a.re(a.i, u, c));
}
function zs(n, t, e, o) {
  return x(ut(((r, i, c, a) => {
    const s = wn(r) + wn(i) * BigInt(a ? -1 : 1);
    return Number.isFinite(Number(s / O)) || h(jn), {
      ...B,
      ...Wn(s, c)
    };
  })(t, e, o, n)));
}
function Xs(n, t, e) {
  const o = $n(t), [r, i, c, a, s] = ((m, p, y) => {
    m = Ue(m, En);
    let g = Ji(m);
    const I = y(m.relativeTo);
    let v = _o(m);
    const D = Ct(m, 7);
    let M = Pt(m);
    return g === void 0 && M === void 0 && h("Required smallestUnit or largestUnit"), M == null && (M = 0), g == null && (g = Math.max(M, p)), Ki(g, M), v = Jo(v, M, 1), v > 1 && M > 5 && g !== M && h("For calendar units with roundingIncrement > 1, use largestUnit = smallestUnit"), [g, M, v, D, I];
  })(e, o, n);
  if (!s && Math.max(o, r) <= 6)
    return x(ut(((m, p, y, g, I) => {
      const v = _e(wn(m), $e(y, g), I);
      return {
        ...B,
        ...Wn(v, p)
      };
    })(t, r, i, c, a)));
  const u = s && ue(s) && r >= 6 && i < 6;
  if (!t.sign && !u)
    return t;
  s || h("Missing relativeTo");
  const d = Ve(s), f = d.G(d.i, t);
  dc(d, f);
  let l = d.re(d.i, f, r);
  return l = qe(l, d.V(f), r, i, c, a, d), x(l);
}
function Ks(n) {
  return n.sign === -1 ? lc(n) : n;
}
function lc(n) {
  return x(q(n));
}
function q(n) {
  const t = {};
  for (const e of P)
    t[e] = -1 * n[e] || 0;
  return t;
}
function He(n, t = P) {
  let e = 0;
  for (const o of t) {
    const r = Math.sign(n[o]);
    r && (e && e !== r && h("Cannot mix duration signs"), e = r);
  }
  return e;
}
function ut(n) {
  for (const e of ps)
    vn(e, n[e], -4294967295, 4294967295, 1);
  const t = wn(n);
  return mc(Number(t / ot)), n;
}
function mc(n) {
  Number.isSafeInteger(n) || h("Out-of-bounds duration");
}
function wn(n) {
  return BigInt(n.days) * O + dt(n);
}
function dt(n) {
  return BigInt(n.hours) * Ha + BigInt(n.minutes) * Va + hc(n);
}
function hc(n) {
  return BigInt(n.seconds) * ot + BigInt(n.milliseconds) * we + BigInt(n.microseconds) * Ga + BigInt(n.nanoseconds);
}
function Wn(n, t = 6) {
  const e = Number(n / O), o = Number(n % O), r = ln[t], i = t <= 3 ? Number(n / BigInt(r)) : e * (Bn / r) + Ft(o, r);
  Number.isFinite(i) || h(jn), t <= 3 && Math.abs(i) / (qn / ln[t]) >= Js && h(jn);
  const c = cr(o, t, P);
  return c[P[t]] = i, c;
}
function Je(n, t = 5) {
  return cr(n, t, P);
}
function yc(n) {
  return !!He(n, Vi);
}
function $n(n) {
  let t = 9;
  for (; t > 0 && !n[P[t]]; t--)
    ;
  return t;
}
function pc(n, t) {
  return C(n.epochNanoseconds, t.epochNanoseconds);
}
function gc(n, t) {
  return C(n.epochNanoseconds, t.epochNanoseconds);
}
function Qs(n, t, e, o) {
  const r = n(Dn(o).relativeTo), i = Math.max($n(t), $n(e));
  if (gi(P, t, e))
    return 0;
  if (Mt(i, r))
    return C(wn(t), wn(e));
  r || h("Missing relativeTo");
  const c = Ve(r);
  return C(Ht(c, t), Ht(c, e));
}
function Ic(n, t) {
  return Yt(n, t) || ar(n, t);
}
function Yt(n, t) {
  return Zn(Tn(n), Tn(t));
}
function ar(n, t) {
  return Zn(K(n), K(t));
}
function nu(n, t) {
  return !pc(n, t);
}
function tu(n, t) {
  return !gc(n, t) && n.timeZone.o === t.timeZone.o && n.calendar === t.calendar;
}
function eu(n, t) {
  return !Ic(n, t) && n.calendar === t.calendar;
}
function ou(n, t) {
  return !Yt(n, t) && n.calendar === t.calendar;
}
function ru(n, t) {
  return !Yt(n, t) && n.calendar === t.calendar;
}
function iu(n, t) {
  return !Yt(n, t) && n.calendar === t.calendar;
}
function cu(n, t) {
  return !ar(n, t);
}
function kt(n) {
  return n === 0 ? $a : n ? n.l : void 0;
}
function _(n, t, e = t) {
  return kt(n) ? e : t;
}
function sr(n, t) {
  const e = n || void 0, o = kt(n);
  let { era: r, eraYear: i, year: c } = t;
  if (c !== void 0 && (c = J(c, "year")), i !== void 0 && (i = J(i, "eraYear")), r !== void 0 || i !== void 0) {
    r !== void 0 && i !== void 0 || S("Mismatching era/eraYear"), o || h("Forbidden era/eraYear");
    const a = Ni(r), s = o[a];
    s === void 0 && h(((d) => `Invalid era: ${d}`)(r));
    const u = e?.te ? e.te(i, a, s) : au(i, s);
    c !== void 0 && c !== u && h("Mismatching year/eraYear"), c = u;
  } else
    c === void 0 && S(Ze(o));
  return c;
}
function Oe(n, t, e, o, r) {
  let { month: i, monthCode: c } = t;
  if (c !== void 0) {
    const a = ((s, u, d, f, l = Ti(u)) => {
      const m = s ? s.q(d) : void 0, [p, y] = l;
      let g = fo(p, y, m);
      if (y) {
        const I = s ? s.m : void 0;
        I === void 0 && h(tt), I > 0 ? (g > I && h(tt), m !== g && (f === 1 && h(tt), g = fo(p, 0, m))) : (g !== -I && h(tt), m === void 0 && f === 1 && h(tt));
      }
      return g;
    })(n, c, e, o, r);
    i !== void 0 && i !== a && h("Mismatching month/monthCode"), i = a, o = 1;
  } else
    i === void 0 && S("Missing month/monthCode");
  return vn("month", i, 1, $t(n, e), o);
}
function Io(n, t, e, o, r) {
  return uo(t, "day", 1, qt(n, o, e), r);
}
function au(n, t) {
  return (t + n) * (Math.sign(t) || 1) || 0;
}
function de(n, t) {
  return Re(Mn($, {
    ...mn,
    ...n
  }), t);
}
const su = /* @__PURE__ */ bt("([+-])(\\d{2})(?::?(\\d{2})(?::?(\\d{2})(?:[.,](\\d{1,9}))?)?)?");
function ze(n) {
  const t = ur(n);
  return t === void 0 && h(pi(n)), t;
}
function ur(n, t) {
  const e = su.exec(n);
  if (e && ((o) => ((r) => {
    r[0] !== "T" && r[0] !== "t" || (r = r.slice(1));
    const i = r.search(/[.,]/), c = i < 0 ? r : r.slice(0, i), a = c.split(":");
    return a.length === 1 ? /^(?:\d{2}|\d{4}|\d{6})$/i.test(c) : (a.length === 2 || a.length === 3) && a.every((s) => s.length === 2 && /^\d{2}$/i.test(s));
  })(o.slice(1)))(e[0]))
    return ((o, r) => {
      const i = o[4] || o[5];
      return r && i && h(Cn(i)), a = (vt(o[2]) * oe + vt(o[3]) * ee + vt(o[4]) * qn + Oo(o[5] || "")) * Po(o[1]), Math.abs(a) >= Bn && h("Out-of-bounds offset"), a;
      var a;
    })(e, t);
}
const cn = {
  era: Wo,
  month: Ar,
  monthCode(n, t = "monthCode") {
    return ((e, o) => {
      if (typeof e == "string")
        return e;
      if (e && typeof e == "object") {
        const r = e.toString;
        if (typeof r == "function")
          return W(r.call(e), o);
      }
      return W(e, o);
    })(n, t);
  },
  day: Ar
}, dr = /* @__PURE__ */ Qt($, J), vc = /* @__PURE__ */ Qt(P, qo), uu = {
  offset(n) {
    return ze(Wo(n));
  }
}, fr = /* @__PURE__ */ Object.assign({}, cn, dr), lr = /* @__PURE__ */ Object.assign({}, fr, uu);
function E(n, t, e, o, r = !o) {
  const i = {};
  let c = 0;
  for (const a of t) {
    let s = n[a];
    if (s !== void 0) {
      c = 1;
      const u = e[a];
      u && (s = u(s, a)), i[a] = s;
    } else
      o && o.includes(a) && S(Kt(a));
  }
  return r && !c && S(mi(t)), i;
}
function Xe(n, t = mn, e) {
  const o = Z(n, t);
  return Et(o), Pn(o, e);
}
function Jt(n, t, e) {
  return Mc(n, t, Nc(n, t), T(e));
}
function Ke(n, t, e) {
  const o = Nc(n, t), r = e();
  return [Mc(n, t, o, r[0]), ...r];
}
function Mc(n, t, e, o) {
  const r = e[1], i = Oe(n, t, r, o, e[0]);
  return b(Q(it(n, r, i, Io(n, t, i, r, o))), n);
}
function mr(n) {
  if (n.monthCode !== void 0)
    return Ti(n.monthCode);
}
function Nc(n, t) {
  const e = kt(n);
  return t.year !== void 0 || t.era !== void 0 && t.eraYear !== void 0 || S(Ze(e)), t.monthCode === void 0 && t.month === void 0 && S("Missing month/monthCode"), t.day === void 0 && S(Kt("day")), [mr(t), sr(n, t)];
}
function hr(n, t, e) {
  const o = kt(n);
  t.year !== void 0 || t.era !== void 0 && t.eraYear !== void 0 || S(Ze(o)), t.monthCode === void 0 && t.month === void 0 && S("Missing month/monthCode");
  const r = mr(t), i = sr(n, t);
  return b(Xo(it(n, i, Oe(n, t, i, T(e), r), 1)), n);
}
function yr(n, t, e) {
  const o = n === fn, r = kt(n);
  t.day === void 0 && S(Kt("day")), o || t.month === void 0 || t.year !== void 0 || t.era !== void 0 && t.eraYear !== void 0 || S(Ze(r));
  const i = mr(t);
  let c = t.eraYear !== void 0 || t.year !== void 0 ? sr(n, t) : void 0;
  const a = T(e);
  let s, u, d;
  if (c === void 0 && o && (c = 1972), c !== void 0) {
    o || Q(it(n, c, 1, 1));
    const p = Oe(n, t, c, a, i);
    s = Io(n, t, p, c, a), [u, d] = rt(n, c, p);
  } else {
    t.monthCode === void 0 && S("Missing month/monthCode"), [u, d] = i;
    const p = n ? n.ge : 1972;
    if (p !== void 0)
      s = Io(n, t, Oe(n, t, p, a, i), p, a);
    else {
      const y = a === 0 && n ? n.ke?.(u, d, t.day) : void 0;
      s = y !== void 0 ? y : t.day;
    }
  }
  d && ((n && n.Z?.[u]) ?? 1 / 0) < t.day && (a === 1 && h(tt), d = 0, s = Do(t.day, 1, (n && n.X) ?? 1 / 0));
  let f = n ? n.v(u, !!d, s) : ho(u, !!d);
  for (; !f && a === 0 && s > 1; )
    s--, f = n ? n.v(u, !!d, s) : ho(u, !!d);
  f || h("Cannot guess year");
  const { year: l, month: m } = f;
  return b(Q(it(n, l, m, s)), n);
}
const Yn = Intl.DateTimeFormat;
function du(n, t) {
  t < -864e13 && h(jn);
  const e = n.formatToParts(t), o = {};
  for (const r of e)
    o[r.type] = r.value;
  return o;
}
const fu = {
  El_Aaiun: 17,
  Tucuman: 12,
  Tirane: 11,
  Riga: 10,
  Simferopol: 9,
  Vienna: 9,
  Tunis: 8,
  Boa_Vista: 6,
  Fortaleza: 6,
  Maceio: 6,
  Noronha: 6,
  Recife: 6,
  Gaza: 6,
  Hebron: 6,
  DeNoronha: 6
}, io = -388152e4;
function Tc(n, t = 4) {
  const e = Go(n), o = Ct(n, 4), r = Pt(n);
  return [o, ...gr(Tt(En, r, 0, t), e)];
}
function pr(n) {
  return Ho(Dn(n));
}
function Dc(n, t) {
  return Tc(Dn(n), t);
}
function gr(n, t) {
  return n != null ? [ln[n], n < 4 ? 9 - 3 * n : -1] : [t === void 0 ? 1 : 10 ** (9 - t), t];
}
function ni(n, t, e) {
  const [o, r, i, c] = ((s) => {
    const u = Go(s = Dn(s)), d = Ct(s, 4), f = Pt(s);
    return [s.timeZone, d, ...gr(Tt(En, f, 0, 4), u)];
  })(e), a = o !== void 0;
  return ((s, u, d, f, l, m) => {
    d = er(d, BigInt(l), f);
    const p = u.C(d);
    return Ir(ce(d + BigInt(p)), m) + (s ? Qe(Se(p)) : "Z");
  })(a, X(a ? n(o) : "UTC"), t.epochNanoseconds, r, i, c);
}
function ti(n, t) {
  const e = ((o) => {
    o = Dn(o);
    const r = Ho(o), i = Go(o), c = ws(o), a = Ct(o, 4), s = Pt(o);
    return [r, Es(o), c, a, ...gr(Tt(En, s, 0, 4), i)];
  })(t);
  return ((o, r, i, c, a, s, u, d, f, l) => {
    c = er(c, BigInt(f), d);
    const m = i.C(c);
    return Ir(ce(c + BigInt(m)), l) + Qe(Se(m), u) + hu(r, s) + vr(o, a);
  })(n.calendar, n.timeZone.id, n.timeZone, n.epochNanoseconds, ...e);
}
function ei(n, t) {
  const e = ((o) => (o = Dn(o), [Ho(o), ...Tc(o)]))(t);
  return ((o, r, i, c, a, s) => Ir(nr(r, a, c), s) + vr(o, i))(n.calendar, n, ...e);
}
function oi(n, t) {
  return e = n.calendar, o = n, r = pr(t), Pe(o) + vr(e, r);
  var e, o, r;
}
function ri(n, t) {
  return Sc(n.calendar, bc, n, pr(t));
}
function ii(n, t) {
  return Sc(n.calendar, mu, n, pr(t));
}
function Sc(n, t, e, o) {
  const r = o > 1 || o === 0 && n !== fn;
  return o === 1 ? n === fn ? t(e) : Pe(e) : r ? Pe(e) + Oc(Nn(n), o === 2) : t(e);
}
function ci(n, t) {
  return ((e, o, r, i) => Fc(tr(e, r, o)[0], i))(n, ...Dc(t));
}
function co(n, t) {
  const [e, o, r] = Dc(t, 3);
  return o > 1 && ut(n = {
    ...n,
    ...js(n, o, e)
  }), lu(n, r);
}
function lu(n, t) {
  const { sign: e } = n, o = e === -1 ? q(n) : n, { hours: r, minutes: i } = o, c = hc(o), a = Number(c / ot), s = Number(c % ot);
  mc(a);
  const u = Mr(s, t), d = t >= 0 || !e || u;
  return (e < 0 ? "-" : "") + "P" + ai({
    Y: nt(o.years),
    M: nt(o.months),
    W: nt(o.weeks),
    D: nt(o.days)
  }) + (r || i || a || d ? "T" + ai({
    H: nt(r),
    M: nt(i),
    S: nt(a, d) + u
  }) : "");
}
function ai(n) {
  const t = [];
  for (const e in n) {
    const o = n[e];
    o && t.push(o, e);
  }
  return t.join("");
}
function nt(n, t) {
  if (!n && !t)
    return "";
  const e = /* @__PURE__ */ Object.create(null);
  return e.useGrouping = 0, n.toLocaleString("fullwide", e);
}
function Ir(n, t) {
  return Pe(n) + "T" + Fc(n, t);
}
function Pe(n) {
  return bc(n) + "-" + dn(n.day);
}
function bc(n) {
  const { year: t } = n;
  return (t < 0 || t > 9999 ? Pc(t) + Ne(6, Math.abs(t)) : Ne(4, t)) + "-" + dn(n.month);
}
function mu(n) {
  return dn(n.month) + "-" + dn(n.day);
}
function Fc(n, t) {
  const e = [dn(n.hour), dn(n.minute)];
  return t !== -1 && e.push(dn(n.second) + ((o, r, i, c) => Mr(o * te + r * ne + i, c))(n.millisecond, n.microsecond, n.nanosecond, t)), e.join(":");
}
function Qe(n, t = 0) {
  if (t === 1)
    return "";
  const [e, o] = gn(Math.abs(n), oe), [r, i] = gn(o, ee), [c, a] = gn(i, qn);
  return Pc(n) + dn(e) + ":" + dn(r) + (c || a ? ":" + dn(c) + Mr(a) : "");
}
function hu(n, t) {
  return t !== 1 ? "[" + (t === 2 ? "!" : "") + n + "]" : "";
}
function vr(n, t) {
  return t > 1 || t === 0 && n !== fn ? Oc(Nn(n), t === 2) : "";
}
function Oc(n, t) {
  return "[" + (t ? "!" : "") + "u-ca=" + n + "]";
}
const yu = /0+$/;
function Mr(n, t) {
  let e = Ne(9, n);
  return e = t === void 0 ? e.replace(yu, "") : e.slice(0, t), e ? "." + e : "";
}
function Pc(n) {
  return n < 0 ? "-" : "+";
}
const pu = /^(AC|AE|AG|AR|AS|BE|BS|CA|CN|CS|CT|EA|EC|IE|IS|JS|MI|NE|NS|PL|PN|PR|PS|SS|VS)T$/, gu = /[^\w\/:+-]+/;
function Iu(n) {
  return Nr(W(n));
}
function Nr(n) {
  return Cc(n).id;
}
function Cc(n) {
  const t = n.toUpperCase(), e = ((r) => {
    const i = ur(r, 1);
    if (i !== void 0)
      return {
        id: Qe(i),
        _: i,
        o: i
      };
  })(t);
  if (e)
    return {
      kind: "fixed",
      ...e
    };
  const o = t === "UTC" ? "UTC" : ((r) => (gu.test(r) && h(yi(r)), pu.test(r) && h("Forbidden ICU TimeZone"), r.toLowerCase().split("/").map((i, c) => (i.length <= 3 || /\d/.test(i)) && !/etc|yap/.test(i) ? i.toUpperCase() : i.replace(/baja|dumont|[a-z]+/g, (a, s) => a.length <= 2 && !c || a === "in" || a === "chat" ? a.toUpperCase() : a.length > 2 || !s ? jr(a).replace(/island|noronha|murdo|rivadavia|urville/, jr) : a)).join("/")))(n);
  return vu(o);
}
const vu = /* @__PURE__ */ Nt((n) => {
  if (n === "UTC")
    return {
      kind: "utc",
      id: n,
      o: n
    };
  const t = n.toUpperCase(), e = Mu(t);
  return {
    kind: "named",
    id: n,
    format: e,
    o: e.resolvedOptions().timeZone
  };
}), Mu = /* @__PURE__ */ Nt((n) => new Yn("en-u-hc-h23", {
  calendar: "iso8601",
  timeZone: n,
  era: "short",
  year: "numeric",
  month: "numeric",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
  second: "numeric"
}));
function X(n) {
  const t = Cc(n);
  return Nu(t.id, t);
}
const Nu = /* @__PURE__ */ Nt((n, t) => t.kind === "named" ? new Du(n, t.o, t.format) : new Tu(n, t.o, t.kind === "fixed" ? t._ : 0));
class Tu {
  constructor(t, e, o) {
    this.id = t, this.o = e, this._ = o;
  }
  C() {
    return this._;
  }
  R(t) {
    return [Ko(t, this._)];
  }
  U() {
  }
}
class Du {
  constructor(t, e, o) {
    this.id = t, this.o = e, this.qe = ((r, i) => {
      const c = Nt(r), a = Nt(Su), s = 86400 * i;
      function u(f) {
        const [l, m] = ui(f, s), p = ve(l), y = ve(m), g = c(p), I = c(y);
        return g === I ? g : d(a(p, y), g, I, f);
      }
      function d(f, l, m, p) {
        let y, g;
        for (; (p === void 0 || (y = p < f[0] ? l : p >= f[1] ? m : void 0) === void 0) && (g = f[1] - f[0]); ) {
          const I = f[0] + Math.floor(g / 2);
          r(I) === m ? f[1] = I : f[0] = I + 1;
        }
        return y;
      }
      return {
        Ee(f) {
          const l = u(f - 86400), m = u(f + 86400), p = f - l, y = f - m;
          if (l === m)
            return [p];
          const g = u(p);
          return g === u(y) ? [f - g] : l > m ? [p, y] : [];
        },
        De: u,
        U: function f(l, m) {
          if (m > 0 && l >= 864e10)
            return;
          if (m < 0) {
            if (l <= io)
              return;
            const M = si() + 94867200;
            if (l > M)
              return f(M, -1);
          }
          const p = m > 0 ? Math.max(l, io) : l;
          let [y, g] = ui(p, s);
          const I = s * m, v = m > 0 ? Math.max(l, si()) + 94867200 : io, D = () => m < 0 ? g > v : y < v;
          for (; D(); ) {
            const M = ve(y), an = ve(g), G = c(M), sn = c(an);
            if (G !== sn) {
              const V = a(M, an);
              d(V, G, sn);
              const L = V[0];
              if ((Zn(L, l) || 1) === m)
                return L;
            }
            y += I, g += I;
          }
        }
      };
    })(/* @__PURE__ */ ((r) => (i) => {
      const c = du(r, 1e3 * i);
      return 86400 * Wt(((a) => {
        const s = a.relatedYear;
        if (s !== void 0)
          return parseInt(s);
        const u = parseInt(a.year);
        return a.era !== void 0 && Ni(a.era) === "bce" ? 1 - u : u;
      })(c), parseInt(c.month), parseInt(c.day)) + 3600 * parseInt(c.hour) + 60 * parseInt(c.minute) + parseInt(c.second) - i;
    })(o), ((r) => {
      const i = r.split("/").pop();
      return fu[i] || 60;
    })(t));
  }
  C(t) {
    return this.qe.De(((e) => Ur(e)[0])(t)) * qn;
  }
  R(t) {
    const e = 86400 * Tn(t) + ko(t), o = Yi(t);
    return this.qe.Ee(e).map((r) => Sn(BigInt(r) * ot + BigInt(o)));
  }
  U(t, e) {
    const [o, r] = Ur(t), i = this.qe.U(o + (e > 0 || r ? 1 : 0), e);
    if (i !== void 0)
      return BigInt(i) * ot;
  }
}
function si() {
  return Math.floor(Date.now() / 1e3);
}
function Su(n, t) {
  return [n, t];
}
function ui(n, t) {
  const e = Math.floor(n / t) * t;
  return [e, e + t];
}
function ve(n) {
  return Do(n, -1e10, 864e10);
}
function bu(n, t, e) {
  const o = E(e, _(t, Ei, wi), lr, [], 0);
  if (o.timeZone !== void 0) {
    const r = Jt(t, o), i = de(o), c = X(n(o.timeZone));
    return {
      epochNanoseconds: Bt(c, Z(r, i), o.offset),
      timeZone: c,
      calendar: t
    };
  }
  return Jt(t, o);
}
function Fu(n, t, e, o) {
  const r = E(e, _(t, Ei, wi), lr, Yo, 0), i = n(r.timeZone), [c, a, s, u] = Ke(t, r, () => _t(o)), d = de(r, a), f = X(i);
  return bn(Bt(f, Z(c, d), r.offset, s, u), f, t);
}
function Ou(n, t, e) {
  const o = E(t, _(n, Ci, Zi), fr, [], 0), [r, i] = Ke(n, o, () => [T(e)]);
  return Xe(r, de(o, i), n);
}
function Pu(n, t, e, o = []) {
  return Jt(n, E(t, _(n, at, st), cn, o), e);
}
function Cu(n, t, e, o) {
  return hr(n, E(t, _(n, re, Fi), cn, o), e);
}
function Zu(n, t, e, o) {
  const r = E(e, _(n, at, st), cn, ct, 0);
  return t && r.month !== void 0 && r.monthCode === void 0 && r.year === void 0 && (r.year = 1972), yr(n, r, o);
}
function Eu(n, t) {
  return de(E(n, mo, dr, [], 1), T(t));
}
function wu(n) {
  const t = E(n, Gi, vc);
  return x(ut({
    ...B,
    ...t
  }));
}
function on(n) {
  h(pi(n));
}
function Bu(n) {
  const t = Hn(n = Wo(n));
  let e;
  return t || on(n), t.F ? e = 0 : t.offset ? e = ze(t.offset) : on(n), t.timeZoneId && ur(t.timeZoneId, 1), je(t), pn(Ko(t, e));
}
function Yu(n, t) {
  const e = Hn(W(n));
  return e || on(n), e.timeZoneId ? Zc(e, t, void 0) : (e.F && on(n), vo(e, t));
}
function ku(n, t, e) {
  const o = Hn(W(n));
  return o && o.timeZoneId || on(n), Zc(o, t, e);
}
function Ru(n, t) {
  const e = Hn(W(n));
  return e && !e.F || on(n), Ec(e, t);
}
function Au(n, t) {
  const e = Sr(Dr(W(n)), void 0, t);
  return b(e, e.calendar);
}
function xu(n, t) {
  const e = Fr(W(n));
  if (e)
    return Tr(e), b(Xo(_n(e)), t(e.calendarId));
  const o = Sr(Dr(n), qu, t), { calendar: r } = o;
  return b(Vt(r, o), r);
}
function Tr(n) {
  n.calendarId !== "iso8601" && h(Cn(n.calendarId));
}
function ju(n, t) {
  const e = Or(W(n));
  if (e)
    return Tr(e), b(_n(e), t(e.calendarId));
  const o = Sr(Dr(n), _u, t), { calendar: r } = o, { year: i, month: c, day: a } = F(r, o), [s, u] = rt(r, i, c), { year: d, month: f } = ((l, m, p, y) => {
    const g = l ? l.v(m, p, y) : ho(m, p);
    return g || h("Cannot guess year"), g;
  })(r, s, u, a);
  return b(Q(it(r, d, f, a)), r);
}
function Uu(n) {
  let t = ((o) => {
    const r = Bc(o);
    return r ? (fe(r[13]), Yc(r, 1)) : void 0;
  })(n = W(n)), e;
  return t || (t = Hn(n), t ? (t.fe || on(n), t.F && h(Cn("Z")), Tr(t)) : on(n)), (e = Fr(n)) && Lr(e) && on(n), (e = Or(n)) && Lr(e) && on(n), wt(ke(t));
}
function Lu(n) {
  const t = ((e) => {
    const o = Ku.exec(e);
    return o ? ((r) => {
      let i = 0, c = 0, a = 0, s = {
        years: u(r[2]),
        months: u(r[3]),
        weeks: u(r[4]),
        days: u(r[5]),
        hours: u(r[6], r[7], 5),
        minutes: u(r[8], r[9], 4),
        seconds: u(r[10], r[11], 3),
        ...cr(a, 2, P)
      };
      return i || h(mi(P)), Po(r[1]) < 0 && (s = q(s)), s;
      function u(d, f, l) {
        let m = 0, p = 0;
        return l && ([m, a] = gn(a, ln[l])), d !== void 0 && (c && h(Cn(d)), p = ((y) => {
          const g = parseInt(y);
          return Number.isFinite(g) || h(Cn(y)), g;
        })(d), i = 1, f && (a = Oo(f) * (ln[l] / qn), c = 1)), m + p;
      }
    })(o) : void 0;
  })(W(n));
  return t || on(n), x(ut(t));
}
function Wu(n) {
  const t = Hn(n) || Fr(n) || Or(n);
  if (t)
    return t.calendarId;
  const e = Bc(n);
  return e ? fe(e[13]).calendarId : n;
}
function $u(n) {
  const t = Hn(n);
  return t && (t.timeZoneId || t.F && "UTC" || t.offset) || n;
}
function Dr(n) {
  const t = Hn(n);
  return t && !t.F || on(n), t;
}
function Sr(n, t, e) {
  return t && n.calendarId === "iso8601" ? (_n(n), n.fe && ke(n), vo(t(n), e)) : n.fe ? Ec(n, e) : vo(n, e);
}
function qu(n) {
  const t = 12 * n.year + n.month === tc ? 20 : 1;
  return {
    ...n,
    day: t
  };
}
function _u(n) {
  return {
    ...n,
    year: 1972
  };
}
function Zc(n, t, e) {
  const o = X(Nr(n.timeZoneId));
  let r;
  if (je(n), n.fe) {
    const c = n.offset ? ze(n.offset) : void 0, [, a, s] = _t(e);
    r = Bt(o, n, c, a, s, !(o._ || n.offset === void 0 || (i = n.offset, i.replace(/\D/g, "").length > 4)), n.F);
  } else
    _t(e), r = Un(o, n);
  var i;
  return Sn(r), bn(r, o, t(n.calendarId));
}
function Ec(n, t) {
  return je(n), Et(n), {
    ...Z(n, n),
    calendar: t(n.calendarId)
  };
}
function vo(n, t) {
  return _n(n), Q(n), {
    calendar: t(n.calendarId),
    year: n.year,
    month: n.month,
    day: n.day
  };
}
function br(n) {
  return `(\\d{2})(?:(:?)(\\d{2})(?:\\${n}(\\d{2})(?:[.,](\\d{1,9}))?)?)?`;
}
function wc(n) {
  return "([+-])" + br(n);
}
const Gu = "(?:(?:([+-])(\\d{6}))|(\\d{4}))(-?)(\\d{2})\\4(\\d{2})(?:[T ]" + br(8) + "(Z|" + wc(15) + ")?)?", Vu = /* @__PURE__ */ bt("(?:(?:([+-])(\\d{6}))|(\\d{4}))-?(\\d{2})((?:\\[(!?)([^\\]]*)\\]){0,9})"), Hu = /* @__PURE__ */ bt("(?:--)?(\\d{2})-?(\\d{2})((?:\\[(!?)([^\\]]*)\\]){0,9})"), Ju = /* @__PURE__ */ bt(Gu + "((?:\\[(!?)([^\\]]*)\\]){0,9})"), zu = /* @__PURE__ */ bt("T?" + br(2) + `(${wc(9)})?((?:\\[(!?)([^\\]]*)\\]){0,9})`), Xu = /* @__PURE__ */ new RegExp("\\[(!?)([^\\]]*)\\]", "g"), Ku = /* @__PURE__ */ bt("([+-])?P(\\d+Y)?(\\d+M)?(\\d+W)?(\\d+D)?(?:T(?:(\\d+)(?:[.,](\\d{1,9}))?H)?(?:(\\d+)(?:[.,](\\d{1,9}))?M)?(?:(\\d+)(?:[.,](\\d{1,9}))?S)?)?");
function Hn(n) {
  const t = Ju.exec(n);
  return t ? ((e) => {
    const o = e[12], r = (o || "").toUpperCase() === "Z";
    return {
      year: kc(e),
      month: parseInt(e[5]),
      day: parseInt(e[6]),
      ...Yc(e, 7),
      ...fe(e[19]),
      fe: !!e[7],
      F: r,
      offset: r ? void 0 : o
    };
  })(t) : void 0;
}
function Fr(n) {
  const t = Vu.exec(n);
  if (t)
    return ((e) => ({
      year: kc(e),
      month: parseInt(e[4]),
      day: 1,
      ...fe(e[5])
    }))(t);
}
function Or(n) {
  const t = Hu.exec(n);
  return t ? ((e) => ({
    year: 1972,
    month: parseInt(e[1]),
    day: parseInt(e[2]),
    ...fe(e[3])
  }))(t) : void 0;
}
function Bc(n) {
  const t = zu.exec(n);
  if (t)
    return t[6] && ze(t[6]), t;
}
function Yc(n, t) {
  const e = vt(n[t + 3]);
  return {
    ...Ro(Oo(n[t + 4] || ""))[0],
    hour: vt(n[t]),
    minute: vt(n[t + 2]),
    second: e === 60 ? 59 : e
  };
}
function kc(n) {
  const t = Po(n[1]), e = parseInt(n[2] || n[3]);
  return t < 0 && !e && h(Cn(-0)), t * e;
}
function fe(n) {
  let t, e;
  const o = [];
  return n.replace(Xu, (r, i, c) => {
    const a = !!i, [s, u] = c.split("=").reverse();
    return u ? u === "u-ca" ? (o.push(s.toLowerCase()), t || (t = a)) : (a || /[A-Z]/.test(u)) && h(Cn(r)) : (e && h(Cn(r)), e = s), "";
  }), o.length > 1 && t && h(Cn(n)), {
    timeZoneId: e,
    calendarId: o[0] || "iso8601"
  };
}
function Rt(n, t, e) {
  const o = Object.assign(/* @__PURE__ */ Object.create(null), t);
  return ao(o, e, bi), kt(n) && (ao(o, e, Ja), n && n.le && ao(o, e, za, Ot)), o;
}
function ao(n, t, e, o) {
  let r = 0;
  const i = [];
  for (const c of e)
    t[c] !== void 0 ? r = 1 : i.push(c);
  if (Object.assign(n, t), r)
    for (const c of o || i)
      delete n[c];
}
function Qu(n, t, e) {
  const { calendar: o, timeZone: r } = n, i = _(o, Ka, Qa), c = j(n), { year: a, month: s, day: u } = F(o, c), d = {
    year: a,
    monthCode: le(o, a, s),
    day: u,
    hour: c.hour,
    minute: c.minute,
    second: c.second,
    millisecond: c.millisecond,
    microsecond: c.microsecond,
    nanosecond: c.nanosecond,
    offset: c.offsetNanoseconds
  }, f = E(t, i, lr), l = Rt(o, d, f), m = {
    ...d,
    ...f
  }, [p, y, g, I] = Ke(o, l, () => _t(e, 2));
  return bn(Bt(r, Z(p, Re(m, y)), m.offset, g, I), r, o);
}
function nd(n, t, e) {
  const { calendar: o } = n, r = _(o, Ci, Zi), { year: i, month: c, day: a } = F(o, n), s = {
    year: i,
    monthCode: le(o, i, c),
    day: a,
    hour: n.hour,
    minute: n.minute,
    second: n.second,
    millisecond: n.millisecond,
    microsecond: n.microsecond,
    nanosecond: n.nanosecond
  }, u = E(t, r, fr), d = Rt(o, s, u), f = {
    ...s,
    ...u
  }, [l, m] = Ke(o, d, () => [T(e)]);
  return Xe(l, Re(f, m), o);
}
function td(n, t, e) {
  const { calendar: o } = n, r = _(o, at, st), { year: i, month: c, day: a } = F(o, n);
  return Jt(o, Rt(o, {
    year: i,
    monthCode: le(o, i, c),
    day: a
  }, E(t, r, cn)), e);
}
function ed(n, t, e) {
  const { calendar: o } = n, r = _(o, re, Fi), { year: i, month: c } = F(o, n);
  return hr(o, Rt(o, {
    year: i,
    monthCode: le(o, i, c)
  }, E(t, r, cn)), e);
}
function od(n, t, e) {
  const { calendar: o } = n, r = _(o, at, st), { year: i, month: c, day: a } = F(o, n);
  return yr(o, Rt(o, {
    monthCode: le(o, i, c),
    day: a
  }, E(t, r, cn)), e);
}
function rd(n, t, e) {
  return ((o, r, i) => de({
    ...Mn(mo, o),
    ...E(r, mo, dr)
  }, T(i)))(n, t, e);
}
function id(n, t) {
  return x((e = n, o = t, ut({
    ...e,
    ...E(o, Gi, vc)
  })));
  var e, o;
}
function le(n, t, e) {
  const [o, r] = rt(n, t, e);
  return Di(o, r);
}
function cd(n, t, e) {
  return bn(n.epochNanoseconds, t, e);
}
function ad(n) {
  return pn(n.epochNanoseconds);
}
function Rc(n) {
  return Pn(j(n), n.calendar);
}
function Ac(n) {
  return b(j(n), n.calendar);
}
function xc(n) {
  return wt(j(n));
}
function sd(n, t, e) {
  const o = ((r, i, c) => {
    const a = ((s) => Xi(Dn(s)))(c);
    return se(r, i, a);
  })(t, n, e);
  return bn(Sn(o), t, n.calendar);
}
function ud(n, t, e, o) {
  const r = n(o.timeZone), i = o.plainTime, c = i !== void 0 ? t(i) : void 0, a = X(r);
  let s;
  return s = c ? se(a, Z(e, c)) : Un(a, Z(e, mn)), bn(s, a, e.calendar);
}
function dd(n, t, e) {
  return jc(n, Mn(_(n, ie, Oi), t), E(Xt(e), ct, cn, []));
}
function fd(n, t, e) {
  const o = _(n, Be, Xa);
  return jc(n, Mn(Pi, t), E(Xt(e), o, cn, []));
}
function ld(n, t) {
  return yr(n, E(t, Pi, cn));
}
function md(n, t, e) {
  return hr(n, E(t, _(n, ie, Oi), cn), e);
}
function jc(n, t, e) {
  const o = _(n, ns, ts);
  let r = Rt(n, t, e);
  return r = E(r, o, cn, []), Jt(n, r);
}
function hd(n) {
  return pn(Sn(BigInt(qo(n)) * we));
}
function yd(n) {
  return pn(Sn($o(n)));
}
function me(n) {
  return n.timeZone = "UTC", ["full", "long"].includes(n.timeStyle) && (n.timeStyle = "medium"), n;
}
function pd(n, t) {
  return n.timeZone !== void 0 && S("Cannot specify TimeZone"), n.timeZone = t, n;
}
function he(n, t, e) {
  const o = n.resolvedOptions().calendar;
  !e && t.calendar === fn || Nn(t.calendar) === o || h("Mismatching Calendars");
}
function ft(n, t, e, o, r) {
  const i = new Set(n), c = new Set(t), a = new Set(e);
  return (s, u) => {
    const d = ((M, an, G, sn) => {
      const V = {
        dateStyle: void 0,
        timeStyle: void 0,
        me: {},
        pe: {},
        xe: {},
        oe: 0,
        ue: 0
      };
      for (const L of Object.keys(M)) {
        const mt = M[L];
        mt === void 0 || sn.has(L) || (an.has(L) ? L === "dateStyle" ? V.dateStyle = mt : L === "timeStyle" ? V.timeStyle = mt : V.me[L] = mt : L === "era" ? V.pe[L] = mt : G.has(L) ? L === "dateStyle" || L === "timeStyle" ? V.ue = 1 : V.oe = 1 : V.xe[L] = mt);
      }
      return V;
    })(s, i, c, a), f = d.dateStyle !== void 0, l = d.timeStyle !== void 0, m = f || l, p = Object.keys(d.me).length > 0, y = d.oe || d.ue, g = p || f || l, I = Object.keys(d.pe).length > 0, v = p || I || d.oe;
    (!u && y || u && y && !g || m && v) && S("Invalid formatting options");
    const D = {};
    return m || g || Object.assign(D, o), Object.assign(D, d.me, d.pe, d.xe), f && (r ? Object.assign(D, r[d.dateStyle]) : D.dateStyle = d.dateStyle), l && (D.timeStyle = d.timeStyle), D;
  };
}
const Uc = {
  year: "numeric",
  month: "numeric",
  day: "numeric"
}, Lc = {
  hour: "numeric",
  minute: "numeric",
  second: "numeric"
}, Pr = /* @__PURE__ */ Object.assign({}, Uc, Lc), gd = /* @__PURE__ */ Object.assign({}, Pr, {
  timeZoneName: "short"
}), Id = {
  year: "numeric",
  month: "numeric"
}, vd = {
  month: "numeric",
  day: "numeric"
}, Cr = ["weekday", "year", "month", "day", "dateStyle"], ye = ["dayPeriod", "hour", "minute", "second", "fractionalSecondDigits", "timeStyle"], Zr = /* @__PURE__ */ Cr.concat(ye), Md = /* @__PURE__ */ ["weekday", "day"].concat(ye), Nd = /* @__PURE__ */ ["weekday", "year"].concat(ye), Td = /* @__PURE__ */ ft(Zr, [], [], Pr), Dd = /* @__PURE__ */ ft(Zr, [], [], gd), Sd = /* @__PURE__ */ ft(Zr, [], ["timeZoneName"], Pr), bd = /* @__PURE__ */ ft(Cr, ye, ["timeZoneName"], Uc), Fd = /* @__PURE__ */ ft(ye, Cr, ["timeZoneName", "era"], Lc), Od = /* @__PURE__ */ ft(["year", "month", "dateStyle"], Md, ["timeZoneName"], Id, {
  full: {
    year: "numeric",
    month: "long"
  },
  long: {
    year: "numeric",
    month: "long"
  },
  medium: {
    year: "numeric",
    month: "short"
  },
  short: {
    year: "2-digit",
    month: "numeric"
  }
}), Pd = /* @__PURE__ */ ft(["month", "day", "dateStyle"], Nd, ["timeZoneName", "era"], vd, {
  full: {
    month: "long",
    day: "numeric"
  },
  long: {
    month: "long",
    day: "numeric"
  },
  medium: {
    month: "short",
    day: "numeric"
  },
  short: {
    month: "numeric",
    day: "numeric"
  }
});
function Cd(n, t) {
  const { timeZone: e } = n, o = j(n), { offsetNanoseconds: r } = o, i = t || mn;
  let c;
  return c = t ? Bt(e, Z(o, i), r, 2) : Un(e, Z(o, i)), bn(c, e, n.calendar);
}
function so(n) {
  const t = Mo(), e = n.C(t);
  return ce(t + BigInt(e));
}
function Mo() {
  return BigInt(Date.now()) * we;
}
function jt() {
  return new Yn().resolvedOptions().timeZone;
}
const Wc = "PlainYearMonth", $c = "PlainMonthDay", qc = "PlainDate", _c = "PlainDateTime", Gc = "PlainTime", Vc = "ZonedDateTime", Hc = "Instant", Jc = "Duration";
function Jn(n, t, e, ...o) {
  Object.defineProperties(t, Ua(n)), Object.defineProperties(t.prototype, bo("Temporal." + n));
  for (const r of o)
    Zd(t.prototype, e, r);
  return t;
}
function Zd(n, t, e) {
  Object.defineProperties(n, St((o) => ({
    get() {
      return o(t(this));
    },
    configurable: 1
  }), e));
}
const zn = xr.name === "noop" ? (n) => {
  Object.defineProperty(n, "_str_", {
    value: n.toJSON()
  });
} : xr;
function Xn() {
  S(Aa);
}
function Kn() {
  S(Ra);
}
const Ed = {
  era(n) {
    return Te(n.calendar, n).era;
  },
  eraYear(n) {
    return Te(n.calendar, n).eraYear;
  },
  year(n) {
    return F(n.calendar, n).year;
  },
  month(n) {
    return F(n.calendar, n).month;
  },
  monthCode(n) {
    return xo(n.calendar, n);
  }
}, Er = {
  era(n) {
    return Te(n.calendar, n).era;
  },
  eraYear(n) {
    return Te(n.calendar, n).eraYear;
  },
  year(n) {
    return F(n.calendar, n).year;
  },
  month(n) {
    return F(n.calendar, n).month;
  },
  monthCode(n) {
    return xo(n.calendar, n);
  },
  day(n) {
    return F(n.calendar, n).day;
  }
}, wd = {
  monthCode(n) {
    return xo(n.calendar, n);
  },
  day(n) {
    return F(n.calendar, n).day;
  }
}, zc = {
  daysInMonth(n) {
    return qi(n.calendar, n);
  },
  daysInYear(n) {
    return _i(n.calendar, n);
  },
  monthsInYear(n) {
    return $i(n.calendar, n);
  },
  inLeapYear(n) {
    return Wi(n.calendar, n);
  }
}, no = {
  dayOfWeek(n) {
    return Ao(n);
  },
  dayOfYear(n) {
    return fs(n.calendar, n);
  },
  weekOfYear(n) {
    return ls(n.calendar, n);
  },
  yearOfWeek(n) {
    return ms(n.calendar, n);
  },
  daysInWeek() {
    return 7;
  },
  daysInMonth(n) {
    return qi(n.calendar, n);
  },
  daysInYear(n) {
    return _i(n.calendar, n);
  },
  monthsInYear(n) {
    return $i(n.calendar, n);
  },
  inLeapYear(n) {
    return Wi(n.calendar, n);
  }
};
function di(n) {
  return Fo(Object.keys(n));
}
di(zc), di(no);
function Qn(n) {
  const t = W(n).toLowerCase();
  return t === Mi ? fn : t === Wa ? qa : void h(ja(n, "temporal-polyfill/full"));
}
function pe(n = Mi) {
  return Qn(n);
}
const Xc = /* @__PURE__ */ new WeakMap(), Kc = /* @__PURE__ */ Jn(Vc, class {
  constructor(n, t, e = void 0) {
    const o = Sn($o(n)), r = X(Iu(t)), i = pe(e);
    Qc(this, bn(o, r, i));
  }
  static from(n, t = void 0) {
    return H(ht(n, t));
  }
  static compare(n, t) {
    return gc(ht(n), ht(t));
  }
  get calendarId() {
    return Nn(N(this).calendar);
  }
  get timeZoneId() {
    return N(this).timeZone.id;
  }
  get epochMilliseconds() {
    return De(N(this));
  }
  get epochNanoseconds() {
    return We(N(this));
  }
  get offset() {
    return Qe(j(N(this)).offsetNanoseconds);
  }
  get offsetNanoseconds() {
    return j(N(this)).offsetNanoseconds;
  }
  get hoursInDay() {
    return As(N(this));
  }
  with(n, t = void 0) {
    return H(Qu(N(this), At(n), t));
  }
  withCalendar(n) {
    return H({
      ...N(this),
      calendar: oo(n)
    });
  }
  withTimeZone(n) {
    return H({
      ...N(this),
      timeZone: X(rn(n))
    });
  }
  withPlainTime(n = void 0) {
    return H(Cd(N(this), Yr(n)));
  }
  add(n, t = void 0) {
    const e = N(this);
    return H(be(e, A(n), t));
  }
  subtract(n, t = void 0) {
    const e = N(this);
    return H(be(e, q(A(n)), t));
  }
  until(n, t = void 0) {
    const e = N(this), o = ht(n), r = Ln(e.calendar, o.calendar);
    return w(x(Vr(0, r, e, o, t)));
  }
  since(n, t = void 0) {
    const e = N(this), o = ht(n), r = Ln(e.calendar, o.calendar);
    return w(x(Vr(1, r, e, o, t)));
  }
  round(n) {
    const t = N(this), [e, o, r] = Le(n);
    return H(Rs(t, e, o, r));
  }
  startOfDay() {
    return H(xs(N(this)));
  }
  equals(n) {
    return tu(N(this), ht(n));
  }
  toInstant() {
    return Rn(ad(N(this)));
  }
  toPlainDateTime() {
    return hn(Rc(N(this)));
  }
  toPlainDate() {
    return yn(Ac(N(this)));
  }
  toPlainTime() {
    return xn(xc(N(this)));
  }
  toLocaleString(n = void 0, t = {}) {
    const e = N(this), o = new Yn(n, pd(Dd(t), Gs(e)));
    return he(o, e), o.format(De(e));
  }
  toString(n = void 0) {
    return ti(N(this), n);
  }
  toJSON() {
    return ti(N(this));
  }
  getTimeZoneTransition(n) {
    const t = N(this), e = $s(t, n);
    return e ? H({
      ...t,
      epochNanoseconds: e
    }) : null;
  }
  valueOf() {
    return Kn();
  }
}, Bd, Er, no, wo);
function H(n) {
  return Qc(Object.create(Kc.prototype), n);
}
function N(n) {
  return Fn(n) || Xn();
}
function Bd(n) {
  const t = N(n);
  return {
    ...j(t),
    calendar: t.calendar
  };
}
function Fn(n) {
  return Xc.get(n);
}
function ht(n, t) {
  if (nn(n)) {
    const e = Fn(n);
    if (e)
      return _t(t), e;
    const o = ge(n);
    return Fu(rn, o, n, t);
  }
  return ku(n, Qn, t);
}
function Qc(n, t) {
  return Xc.set(n, t), zn(n), n;
}
function rn(n) {
  if (nn(n)) {
    const t = Fn(n);
    return t || S(yi(n)), t.timeZone.id;
  }
  return ((t) => Nr($u(W(t))))(n);
}
const na = /* @__PURE__ */ new WeakMap(), ta = /* @__PURE__ */ Jn(Hc, class {
  constructor(n) {
    const t = Sn($o(n));
    ea(this, pn(t));
  }
  static from(n) {
    return Rn(yt(n));
  }
  static fromEpochMilliseconds(n) {
    return Rn(hd(n));
  }
  static fromEpochNanoseconds(n) {
    return Rn(yd(n));
  }
  static compare(n, t) {
    return pc(yt(n), yt(t));
  }
  get epochMilliseconds() {
    return De(tn(this));
  }
  get epochNanoseconds() {
    return We(tn(this));
  }
  add(n) {
    const t = tn(this);
    return Rn(pn(_r(t.epochNanoseconds, A(n))));
  }
  subtract(n) {
    const t = tn(this);
    return Rn(pn(_r(t.epochNanoseconds, q(A(n)))));
  }
  until(n, t = void 0) {
    return w(Gr(0, tn(this), yt(n), t));
  }
  since(n, t = void 0) {
    return w(Gr(1, tn(this), yt(n), t));
  }
  round(n) {
    const t = tn(this), [e, o, r] = Le(n, 5, 1);
    return Rn(pn(er(t.epochNanoseconds, $e(e, o), r)));
  }
  equals(n) {
    return nu(tn(this), yt(n));
  }
  toZonedDateTimeISO(n) {
    return H(cd(tn(this), X(rn(n))));
  }
  toLocaleString(n = void 0, t = {}) {
    const e = tn(this);
    return new Yn(n, Td(t)).format(De(e));
  }
  toString(n = void 0) {
    return ni(rn, tn(this), n);
  }
  toJSON() {
    return ni(rn, tn(this));
  }
  valueOf() {
    return Kn();
  }
});
function Rn(n) {
  return ea(Object.create(ta.prototype), n);
}
function tn(n) {
  return wr(n) || Xn();
}
function wr(n) {
  return na.get(n);
}
function yt(n) {
  if (nn(n)) {
    const t = wr(n);
    if (t)
      return t;
    const e = Fn(n);
    if (e)
      return pn(e.epochNanoseconds);
  }
  return Bu(n);
}
function ea(n, t) {
  return na.set(n, t), zn(n), n;
}
const oa = /* @__PURE__ */ new WeakMap(), ra = /* @__PURE__ */ Jn($c, class {
  constructor(n, t, e = void 0, o) {
    const r = J(n), i = J(t), c = pe(e), a = J(o ?? is), s = Q(_n({
      year: a,
      month: r,
      day: i
    }));
    ia(this, b(s, c));
  }
  static from(n, t = void 0) {
    return No(fi(n, t));
  }
  get calendarId() {
    return Nn(kn(this).calendar);
  }
  with(n, t = void 0) {
    return No(od(kn(this), At(n), t));
  }
  equals(n) {
    return iu(kn(this), fi(n));
  }
  toPlainDate(n) {
    const t = kn(this);
    return yn(fd(t.calendar, this, n));
  }
  toLocaleString(n = void 0, t = {}) {
    const e = kn(this), o = new Yn(n, me(Pd(t)));
    return he(o, e, 1), o.format(Ae(e));
  }
  toString(n = void 0) {
    return ii(kn(this), n);
  }
  toJSON() {
    return ii(kn(this));
  }
  valueOf() {
    return Kn();
  }
}, kn, wd);
function No(n) {
  return ia(Object.create(ra.prototype), n);
}
function kn(n) {
  return to(n) || Xn();
}
function to(n) {
  return oa.get(n);
}
function fi(n, t) {
  if (nn(n)) {
    const o = to(n);
    if (o)
      return T(t), o;
    const r = Ia(n);
    return Zu(r === void 0 ? fn : r, r === void 0, n, t);
  }
  const e = ju(n, Qn);
  return T(t), e;
}
function ia(n, t) {
  return oa.set(n, t), zn(n), n;
}
const ca = /* @__PURE__ */ new WeakMap(), aa = /* @__PURE__ */ Jn(Wc, class {
  constructor(n, t, e = void 0, o) {
    const r = J(n), i = J(t), c = pe(e), a = J(o ?? 1), s = Xo(_n({
      year: r,
      month: i,
      day: a
    }));
    sa(this, b(s, c));
  }
  static from(n, t = void 0) {
    return Lt(pt(n, t));
  }
  static compare(n, t) {
    return Yt(pt(n), pt(t));
  }
  get calendarId() {
    return Nn(en(this).calendar);
  }
  with(n, t = void 0) {
    return Lt(ed(en(this), At(n), t));
  }
  add(n, t = void 0) {
    const e = en(this);
    return Lt(b(qr(0, e.calendar, e, A(n), t), e.calendar));
  }
  subtract(n, t = void 0) {
    const e = en(this);
    return Lt(b(qr(1, e.calendar, e, A(n), t), e.calendar));
  }
  until(n, t = void 0) {
    const e = en(this), o = pt(n), r = Ln(e.calendar, o.calendar);
    return w(zr(0, r, e, o, t));
  }
  since(n, t = void 0) {
    const e = en(this), o = pt(n), r = Ln(e.calendar, o.calendar);
    return w(zr(1, r, e, o, t));
  }
  equals(n) {
    return ru(en(this), pt(n));
  }
  toPlainDate(n) {
    const t = en(this);
    return yn(dd(t.calendar, this, n));
  }
  toLocaleString(n = void 0, t = {}) {
    const e = en(this), o = new Yn(n, me(Od(t)));
    return he(o, e, 1), o.format(Ae(e));
  }
  toString(n = void 0) {
    return ri(en(this), n);
  }
  toJSON() {
    return ri(en(this));
  }
  valueOf() {
    return Kn();
  }
}, en, Ed, zc);
function Lt(n) {
  return sa(Object.create(aa.prototype), n);
}
function en(n) {
  return eo(n) || Xn();
}
function eo(n) {
  return ca.get(n);
}
function pt(n, t) {
  if (nn(n)) {
    const o = eo(n);
    if (o)
      return T(t), o;
    const r = ge(n);
    return Cu(r, n, t);
  }
  const e = xu(n, Qn);
  return T(t), e;
}
function sa(n, t) {
  return ca.set(n, t), zn(n), n;
}
function Yd(n) {
  if (!nn(n))
    return;
  let t = wr(n);
  return t ? [Hc, t] : (t = Fn(n), t ? [Vc, t] : (t = lt(n), t ? [_c, t] : (t = xt(n), t ? [qc, t] : (t = Br(n), t ? [Gc, t] : (t = eo(n), t ? [Wc, t] : (t = to(n), t ? [$c, t] : (t = kr(n), t ? [Jc, t] : void 0)))))));
}
function At(n) {
  return (Yd(n) || n.calendar !== void 0 || n.timeZone !== void 0) && S(ka), n;
}
const ua = /* @__PURE__ */ new WeakMap(), da = /* @__PURE__ */ Jn(Gc, class {
  constructor(n = 0, t = 0, e = 0, o = 0, r = 0, i = 0) {
    const c = ke(St(J, {
      hour: n,
      minute: t,
      second: e,
      millisecond: o,
      microsecond: r,
      nanosecond: i
    }));
    fa(this, wt(c));
  }
  static from(n, t = void 0) {
    return xn(An(n, t));
  }
  static compare(n, t) {
    return ar(An(n), An(t));
  }
  with(n, t = void 0) {
    return xn(rd(un(this), At(n), t));
  }
  add(n) {
    const t = un(this);
    return xn(yo(t, A(n))[0]);
  }
  subtract(n) {
    const t = un(this);
    return xn(yo(t, q(A(n)))[0]);
  }
  until(n, t = void 0) {
    return w(Xr(0, un(this), An(n), t));
  }
  since(n, t = void 0) {
    return w(Xr(1, un(this), An(n), t));
  }
  round(n) {
    const t = un(this), [e, o, r] = Le(n, 5);
    return xn(tr(t, ae(e, o), r)[0]);
  }
  equals(n) {
    return cu(un(this), An(n));
  }
  toLocaleString(n = void 0, t = {}) {
    const e = un(this);
    return new Yn(n, me(Fd(t))).format(Bi(e));
  }
  toString(n = void 0) {
    return ci(un(this), n);
  }
  toJSON() {
    return ci(un(this));
  }
  valueOf() {
    return Kn();
  }
}, un, wo);
function xn(n) {
  return fa(Object.create(da.prototype), n);
}
function un(n) {
  return Br(n) || Xn();
}
function Br(n) {
  return ua.get(n);
}
function An(n, t) {
  if (nn(n)) {
    const o = Br(n);
    if (o)
      return T(t), o;
    const r = lt(n);
    if (r)
      return T(t), wt(r);
    const i = Fn(n);
    return i ? (T(t), xc(i)) : Eu(n, t);
  }
  const e = Uu(n);
  return T(t), e;
}
function Yr(n) {
  return n === void 0 ? void 0 : An(n);
}
function fa(n, t) {
  return ua.set(n, t), zn(n), n;
}
const la = /* @__PURE__ */ new WeakMap(), ma = /* @__PURE__ */ Jn(_c, class {
  constructor(n, t, e, o = 0, r = 0, i = 0, c = 0, a = 0, s = 0, u = void 0) {
    const d = Et(je(St(J, {
      year: n,
      month: t,
      day: e,
      hour: o,
      minute: r,
      second: i,
      millisecond: c,
      microsecond: a,
      nanosecond: s
    }))), f = pe(u);
    ha(this, Pn(d, f));
  }
  static from(n, t = void 0) {
    return hn(gt(n, t));
  }
  static compare(n, t) {
    const e = gt(n), o = gt(t);
    return Ic(e, o);
  }
  get calendarId() {
    return Nn(R(this).calendar);
  }
  with(n, t = void 0) {
    return hn(nd(R(this), At(n), t));
  }
  withCalendar(n) {
    const t = R(this);
    return hn(Pn(t, oo(n)));
  }
  withPlainTime(n = void 0) {
    const t = R(this);
    return hn(Xe(t, Yr(n), t.calendar));
  }
  add(n, t = void 0) {
    const e = R(this);
    return hn(Pn(Fe(e.calendar, e, A(n), t), e.calendar));
  }
  subtract(n, t = void 0) {
    const e = R(this);
    return hn(Pn(Fe(e.calendar, e, q(A(n)), t), e.calendar));
  }
  until(n, t = void 0) {
    const e = R(this), o = gt(n), r = Ln(e.calendar, o.calendar);
    return w(Hr(0, r, e, o, t));
  }
  since(n, t = void 0) {
    const e = R(this), o = gt(n), r = Ln(e.calendar, o.calendar);
    return w(Hr(1, r, e, o, t));
  }
  round(n) {
    const t = R(this), [e, o, r] = Le(n);
    return hn(Pn(nr(t, ae(e, o), r), t.calendar));
  }
  equals(n) {
    return eu(R(this), gt(n));
  }
  toZonedDateTime(n, t = void 0) {
    return H(sd(R(this), X(rn(n)), t));
  }
  toPlainDate() {
    const n = R(this);
    return yn(b(n, n.calendar));
  }
  toPlainTime() {
    return xn(wt(R(this)));
  }
  toLocaleString(n = void 0, t = {}) {
    const e = R(this), o = new Yn(n, me(Sd(t)));
    return he(o, e), o.format(rs(e));
  }
  toString(n = void 0) {
    return ei(R(this), n);
  }
  toJSON() {
    return ei(R(this));
  }
  valueOf() {
    return Kn();
  }
}, R, Er, no, wo);
function hn(n) {
  return ha(Object.create(ma.prototype), n);
}
function R(n) {
  return lt(n) || Xn();
}
function lt(n) {
  return la.get(n);
}
function gt(n, t) {
  if (nn(n)) {
    const o = lt(n);
    if (o)
      return T(t), o;
    const r = xt(n);
    if (r)
      return T(t), Pn(Z(r, mn), r.calendar);
    const i = Fn(n);
    if (i)
      return T(t), Rc(i);
    const c = ge(n);
    return Ou(c, n, t);
  }
  const e = Ru(n, Qn);
  return T(t), e;
}
function ha(n, t) {
  return la.set(n, t), zn(n), n;
}
const ya = /* @__PURE__ */ new WeakMap(), pa = /* @__PURE__ */ Jn(qc, class {
  constructor(n, t, e, o = void 0) {
    const r = Q(_n(St(J, {
      year: n,
      month: t,
      day: e
    }))), i = pe(o);
    ga(this, b(r, i));
  }
  static from(n, t = void 0) {
    return yn(It(n, t));
  }
  static compare(n, t) {
    return Yt(It(n), It(t));
  }
  get calendarId() {
    return Nn(U(this).calendar);
  }
  with(n, t = void 0) {
    const e = U(this);
    return yn(td(e, At(n), t));
  }
  withCalendar(n) {
    const t = U(this);
    return yn(b(t, oo(n)));
  }
  add(n, t = void 0) {
    const e = U(this);
    return yn(b(Gt(e.calendar, e, A(n), t), e.calendar));
  }
  subtract(n, t = void 0) {
    const e = U(this);
    return yn(b(Gt(e.calendar, e, q(A(n)), t), e.calendar));
  }
  until(n, t = void 0) {
    const e = U(this), o = It(n), r = Ln(e.calendar, o.calendar);
    return w(Jr(0, r, e, o, t));
  }
  since(n, t = void 0) {
    const e = U(this), o = It(n), r = Ln(e.calendar, o.calendar);
    return w(Jr(1, r, e, o, t));
  }
  equals(n) {
    return ou(U(this), It(n));
  }
  toZonedDateTime(n) {
    const t = nn(n) ? {
      timeZone: n.timeZone,
      plainTime: n.plainTime
    } : {
      timeZone: n
    };
    return H(ud(rn, An, U(this), t));
  }
  toPlainDateTime(n = void 0) {
    const t = U(this);
    return hn(Xe(t, Yr(n), t.calendar));
  }
  toPlainYearMonth() {
    const n = U(this);
    return Lt(md(n.calendar, this));
  }
  toPlainMonthDay() {
    const n = U(this);
    return No(ld(n.calendar, this));
  }
  toLocaleString(n = void 0, t = {}) {
    const e = U(this), o = new Yn(n, me(bd(t)));
    return he(o, e), o.format(Ae(e));
  }
  toString(n = void 0) {
    return oi(U(this), n);
  }
  toJSON() {
    return oi(U(this));
  }
  valueOf() {
    return Kn();
  }
}, U, Er, no);
function yn(n) {
  return ga(Object.create(pa.prototype), n);
}
function U(n) {
  return xt(n) || Xn();
}
function xt(n) {
  return ya.get(n);
}
function It(n, t) {
  if (nn(n)) {
    const o = xt(n);
    if (o)
      return T(t), o;
    const r = lt(n);
    if (r)
      return T(t), b(r, r.calendar);
    const i = Fn(n);
    if (i)
      return T(t), Ac(i);
    const c = ge(n);
    return Pu(c, n, t);
  }
  const e = Au(n, Qn);
  return T(t), e;
}
function ga(n, t) {
  return ya.set(n, t), zn(n), n;
}
function ge(n) {
  const t = Ia(n);
  return t === void 0 ? fn : t;
}
function Ia(n) {
  const { calendar: t } = n;
  if (t !== void 0)
    return oo(t);
}
function oo(n) {
  if (nn(n)) {
    const t = xt(n) || lt(n) || Fn(n) || to(n) || eo(n);
    return t || S(xa(n)), t.calendar;
  }
  return ((t) => Qn(Wu(W(t))))(n);
}
const va = /* @__PURE__ */ new WeakMap(), Ma = /* @__PURE__ */ Jn(Jc, class {
  constructor(n = 0, t = 0, e = 0, o = 0, r = 0, i = 0, c = 0, a = 0, s = 0, u = 0) {
    const d = ut(St(qo, {
      years: n,
      months: t,
      weeks: e,
      days: o,
      hours: r,
      minutes: i,
      seconds: c,
      milliseconds: a,
      microseconds: s,
      nanoseconds: u
    }));
    Na(this, x(d));
  }
  static from(n) {
    return w(A(n));
  }
  static compare(n, t, e = void 0) {
    return Qs(Ut, A(n), A(t), e);
  }
  get sign() {
    return z(this).sign;
  }
  get blank() {
    return !z(this).sign;
  }
  with(n) {
    return w(id(z(this), n));
  }
  negated() {
    return w(lc(z(this)));
  }
  abs() {
    return w(Ks(z(this)));
  }
  add(n, t = void 0) {
    return w(Qr(Ut, 0, z(this), A(n), t));
  }
  subtract(n, t = void 0) {
    return w(Qr(Ut, 1, z(this), A(n), t));
  }
  round(n) {
    return w(Xs(Ut, z(this), n));
  }
  total(n) {
    return Ys(Ut, z(this), n);
  }
  toLocaleString(n = void 0, t) {
    const e = z(this);
    return Intl.DurationFormat ? new Intl.DurationFormat(n, t).format(e) : co(e, t);
  }
  toString(n = void 0) {
    return co(z(this), n);
  }
  toJSON() {
    return co(z(this));
  }
  valueOf() {
    return Kn();
  }
}, z, hs);
function w(n) {
  return Na(Object.create(Ma.prototype), n);
}
function z(n) {
  return kr(n) || Xn();
}
function kr(n) {
  return va.get(n);
}
function A(n) {
  return nn(n) ? kr(n) || wu(n) : Lu(n);
}
function Ut(n) {
  if (n !== void 0) {
    if (nn(n)) {
      const t = Fn(n);
      if (t)
        return t;
      const e = xt(n);
      if (e)
        return e;
      const o = lt(n);
      if (o)
        return b(o, o.calendar);
      const r = ge(n);
      return bu(rn, r, n);
    }
    return Yu(n, Qn);
  }
}
function Na(n, t) {
  return va.set(n, t), zn(n), n;
}
const kd = /* @__PURE__ */ Object.defineProperties({}, {
  ...bo("Temporal.Now"),
  ...So({
    timeZoneId() {
      return jt();
    },
    instant() {
      return Rn(pn(Mo()));
    },
    zonedDateTimeISO(n = jt()) {
      const t = X(rn(n));
      return H(bn(Mo(), t));
    },
    plainDateTimeISO(n = jt()) {
      const t = so(X(rn(n)));
      return hn(Pn(t));
    },
    plainDateISO(n = jt()) {
      const t = so(X(rn(n)));
      return yn(b(t));
    },
    plainTimeISO(n = jt()) {
      const t = so(X(rn(n)));
      return xn(wt(t));
    }
  })
}), Rd = /* @__PURE__ */ Object.defineProperties({}, {
  ...bo("Temporal"),
  ...So({
    PlainYearMonth: aa,
    PlainMonthDay: ra,
    PlainDate: pa,
    PlainTime: da,
    PlainDateTime: ma,
    ZonedDateTime: Kc,
    Instant: ta,
    Duration: Ma,
    Now: kd
  })
}), On = Da || Rd;
function xd(n) {
  const t = On.Now.timeZoneId();
  if (n instanceof On.ZonedDateTime)
    return n.withTimeZone(t);
  if (n instanceof On.PlainDateTime)
    return n.toZonedDateTime(t);
  if (typeof n == "string") {
    if (Ta(n))
      try {
        return On.ZonedDateTime.from(n).withTimeZone(t);
      } catch {
        return On.Instant.from(n).toZonedDateTimeISO(t);
      }
    return On.PlainDateTime.from(n).toZonedDateTime(t);
  }
  let e;
  if (n instanceof On.Instant)
    e = n;
  else if (n instanceof Date)
    e = On.Instant.fromEpochMilliseconds(n.getTime());
  else if (typeof n == "number")
    e = On.Instant.fromEpochMilliseconds(n);
  else
    throw new TypeError("Unsupported input type");
  return e.toZonedDateTimeISO(t);
}
export {
  On as T,
  xd as n
};
